import './scss/main.scss';

(function () {
  'use strict';

  // Manual scroll restoration — Chrome restores scroll before fluid font-size
  // applies, causing a position mismatch. We save/restore it ourselves after layout.
  // Only on refresh (type === 1 or 'reload'), not on normal navigation.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('beforeunload', function () {
    // Save the current URL so we only restore on the same page (refresh).
    sessionStorage.setItem('farseer_scrollY', window.scrollY);
    sessionStorage.setItem('farseer_scrollURL', window.location.href);
  });

  window.addEventListener('load', function () {
    var saved    = sessionStorage.getItem('farseer_scrollY');
    var savedURL = sessionStorage.getItem('farseer_scrollURL');

    sessionStorage.removeItem('farseer_scrollY');
    sessionStorage.removeItem('farseer_scrollURL');

    // Only restore if same page (refresh), not navigation to a different page.
    if (saved !== null && savedURL === window.location.href) {
      requestAnimationFrame(function () {
        window.scrollTo(0, parseInt(saved, 10));
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {

    // ── Initial layout reads — batched (TIC-629) ─────────────────────────
    // Lighthouse's forced-reflow audit flagged the init handlers below:
    // each one read layout (offsetHeight / getBoundingClientRect /
    // scrollWidth) AFTER an earlier handler had already written styles,
    // so every read forced a fresh synchronous layout (~77 ms total on a
    // throttled mobile CPU). Reading everything up front, before the first
    // write, collapses that chain into the single unavoidable first layout.
    // The values are used for each handler's INITIAL call only — resize /
    // scroll / observer paths keep reading live as before.
    var initialLayout = (function () {
      var header = document.querySelector('.site-header');
      var sliderScrollable = new Map();
      document.querySelectorAll('.el-slider').forEach(function (section) {
        if (section.classList.contains('el-slider--grid')) return;
        var track = section.querySelector('.el-slider__track');
        if (track) sliderScrollable.set(track, track.scrollWidth > track.clientWidth + 1);
      });
      return {
        headerHeight: header ? header.offsetHeight : 0,
        headerBottom: header ? Math.max(0, header.getBoundingClientRect().bottom) : 0,
        sliderScrollable: sliderScrollable
      };
    })();

    // ── Scroll offset for anchor links (accounts for sticky header) ────
    (function () {
      var header = document.querySelector('.site-header');
      if (!header) return;
      function setOffset(cachedHeight) {
        var h = typeof cachedHeight === 'number' ? cachedHeight : header.offsetHeight;
        document.documentElement.style.setProperty(
          '--scroll-offset', (h + 40) + 'px'
        );
      }
      setOffset(initialLayout.headerHeight);
      window.addEventListener('resize', function () { setOffset(); });
    })();

    // ── Wide images (container / full width) ────────────────────────────
    (function () {
      var wideImages = document.querySelectorAll('.art-image--container, .art-image--full');
      if (!wideImages.length) return;

      function positionWideImages() {
        wideImages.forEach(function (el) {
          var layout = el.closest('.single-layout');
          if (!layout) return;

          var isFull = el.classList.contains('art-image--full');
          var layoutRect = layout.getBoundingClientRect();
          var elRect = el.getBoundingClientRect();
          var offsetLeft = elRect.left - layoutRect.left;

          if (isFull) {
            // Edge to edge — span full .single-layout width
            el.style.marginLeft = -offsetLeft + 'px';
            el.style.width = layoutRect.width + 'px';
          } else {
            // Container — respect container padding
            var pad = parseFloat(getComputedStyle(layout).paddingLeft) || 0;
            el.style.marginLeft = -(offsetLeft - pad) + 'px';
            el.style.width = (layoutRect.width - pad * 2) + 'px';
          }
        });
      }

      positionWideImages();
      window.addEventListener('resize', positionWideImages);
    })();

    // ── FAQ accordion animation (single open — closes siblings) ─────
    (function () {
      document.querySelectorAll('.art-faq').forEach(function (faq) {
        var items = faq.querySelectorAll('.art-faq__item');
        if (!items.length) return;

        function closeItem(details) {
          var startHeight = details.offsetHeight + 'px';
          details.open = false;
          var endHeight = details.offsetHeight + 'px';
          details.open = true;

          var anim = details.animate(
            { height: [startHeight, endHeight] },
            { duration: 300, easing: 'ease-out' }
          );

          anim.onfinish = function () {
            details.open = false;
            details.style.height = '';
            details.style.overflow = '';
          };

          details.style.overflow = 'hidden';
        }

        items.forEach(function (details) {
          var summary = details.querySelector('.art-faq__question');
          var answer = details.querySelector('.art-faq__answer');
          if (!summary || !answer) return;

          var animation = null;

          summary.addEventListener('click', function (e) {
            e.preventDefault();

            if (animation) animation.cancel();

            if (details.open) {
              // Closing
              var startHeight = details.offsetHeight + 'px';
              details.open = false;
              var endHeight = details.offsetHeight + 'px';
              details.open = true;

              animation = details.animate(
                { height: [startHeight, endHeight] },
                { duration: 300, easing: 'ease-out' }
              );

              animation.onfinish = function () {
                details.open = false;
                details.style.height = '';
                details.style.overflow = '';
                animation = null;
              };

              details.style.overflow = 'hidden';
            } else {
              // Close all other open items in this FAQ
              items.forEach(function (other) {
                if (other !== details && other.open) {
                  closeItem(other);
                }
              });

              // Opening
              var startHeight = details.offsetHeight + 'px';
              details.open = true;
              var endHeight = details.offsetHeight + 'px';

              animation = details.animate(
                { height: [startHeight, endHeight] },
                { duration: 300, easing: 'ease-out' }
              );

              animation.onfinish = function () {
                details.style.height = '';
                details.style.overflow = '';
                animation = null;
              };

              details.style.overflow = 'hidden';
            }
          });
        });
      });
    })();

    // ── Code syntax highlighting (lazy-loaded, core + common languages) ─
    if (document.querySelector('.art-code__content')) {
      Promise.all([
        import('highlight.js/lib/core'),
        import('highlight.js/styles/vs2015.css'),
        import('highlight.js/lib/languages/javascript'),
        import('highlight.js/lib/languages/typescript'),
        import('highlight.js/lib/languages/php'),
        import('highlight.js/lib/languages/css'),
        import('highlight.js/lib/languages/scss'),
        import('highlight.js/lib/languages/xml'),
        import('highlight.js/lib/languages/json'),
        import('highlight.js/lib/languages/bash'),
        import('highlight.js/lib/languages/python'),
        import('highlight.js/lib/languages/sql'),
      ]).then(function (modules) {
        var hljs = modules[0].default;
        hljs.registerLanguage('javascript', modules[2].default);
        hljs.registerLanguage('typescript', modules[3].default);
        hljs.registerLanguage('php', modules[4].default);
        hljs.registerLanguage('css', modules[5].default);
        hljs.registerLanguage('scss', modules[6].default);
        hljs.registerLanguage('xml', modules[7].default);
        hljs.registerLanguage('html', modules[7].default);
        hljs.registerLanguage('json', modules[8].default);
        hljs.registerLanguage('bash', modules[9].default);
        hljs.registerLanguage('python', modules[10].default);
        hljs.registerLanguage('sql', modules[11].default);
        hljs.highlightAll();
      });
    }

    // ── Loader animation ──────────────────────────────────────────────────
    (function () {
      var loader = document.getElementById('js-loader');
      if (!loader) return;

      var textClip = loader.querySelector('.loader__text-clip');
      var chars = loader.querySelectorAll('.loader__char');
      var brand = loader.querySelector('.loader__brand');

      // Compute full text width from CSS variable
      var h = parseFloat(getComputedStyle(loader).getPropertyValue('--loader-h'));
      var fullTextWidth = h * 96 / 21;

      // Right-edge fractions for each character (f, a, r, s, e, e, r)
      var edges = [0.222, 0.369, 0.479, 0.597, 0.746, 0.896, 1];

      // Phase 1 — reveal characters one by one
      setTimeout(function () {
        var i = 0;
        var interval = setInterval(function () {
          if (i >= chars.length) {
            clearInterval(interval);
            startExit();
            return;
          }
          chars[i].classList.add('is-visible');
          textClip.style.width = (edges[i] * fullTextWidth) + 'px';
          i++;
        }, 70);
      }, 400);

      function startExit() {
        var header = document.querySelector('.site-header');
        var siteMain = document.querySelector('.site-main');
        var siteFooter = document.querySelector('.site-footer');
        var headerSlide = document.body.getAttribute('data-header-slide') === '1';

        // Shrink the logo
        brand.classList.add('is-shrinking');

        // Fade loader background
        loader.classList.add('is-exiting');

        // After loader is gone, reveal everything together
        setTimeout(function () {
          loader.remove();

          if (siteMain) siteMain.style.transition = 'transform 0.7s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.7s ease';
          if (siteFooter) siteFooter.style.transition = 'transform 0.7s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.7s ease';

          // Keep header hidden during delay
          if (header && headerSlide) header.classList.add('is-header-hidden');

          document.body.classList.remove('is-loading');

          if (header && headerSlide) {
            setTimeout(function () {
              header.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  header.classList.remove('is-header-hidden');
                });
              });
            }, 500);
          }

          // Image starts immediately with the page slide
          var animHero = document.querySelector('.el-hero--animate');
          if (animHero) animHero.classList.add('is-image-visible');

          // Text animates after page slide finishes
          if (animHero) {
            setTimeout(function () {
              animHero.classList.add('is-visible');
            }, 700);
          }

          setTimeout(function () {
            if (header) header.style.transition = '';
            if (siteMain) siteMain.style.transition = '';
            if (siteFooter) siteFooter.style.transition = '';
            window.dispatchEvent(new CustomEvent('farseer:revealed'));
          }, 700);
        }, 700);
      }
    })();

    // ── Promo banner — slide in + colour fade ────────────────────────────
    // The banner element is in the document flow from page load (so the
    // layout never shifts). Phase 1: add `is-visible` to translate the card
    // down into its slot. Phase 2 (after a short pause): add `is-faded` to
    // swap the brand-blue background for off-white.
    (function () {
      var banner = document.querySelector('[data-promo-banner]');
      if (!banner) return;

      var FADE_DELAY = 2200; // time the blue card holds before the colour swap (ms)

      function start() {
        // Defer one frame so the initial -100% transform is committed
        // before we add the class that animates back to 0 — guarantees
        // the slide actually plays on first paint.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            banner.classList.add('is-visible');
          });
        });

        window.setTimeout(function () {
          banner.classList.add('is-faded');
        }, FADE_DELAY);
      }

      // If the loader is on, wait for its reveal event so the banner slides
      // in alongside the rest of the page. Otherwise kick it off as soon as
      // we're ready.
      if (document.getElementById('js-loader')) {
        window.addEventListener('farseer:revealed', start, { once: true });
      } else {
        start();
      }
    })();

    // ── Hero animate — split heading into lines & stagger ────────────────
    (function () {
      var hero = document.querySelector('.el-hero--animate');
      if (!hero) return;

      // Split heading into visual lines
      var heading = hero.querySelector('.el-hero__heading');
      var lineCount = 0;

      if (heading) {
        var text = heading.textContent.trim();
        var words = text.split(/\s+/);

        // Wrap each word in an inline span for measurement
        heading.innerHTML = words.map(function (w) {
          return '<span style="display:inline;white-space:nowrap">' + w + '</span>';
        }).join(' ');

        // Group words by their vertical offset (= visual line)
        var spans = heading.querySelectorAll('span');
        var lines = [];
        var currentLine = [];
        var currentTop = null;

        spans.forEach(function (span) {
          var top = span.offsetTop;
          if (currentTop !== null && top !== currentTop) {
            lines.push(currentLine);
            currentLine = [];
          }
          currentTop = top;
          currentLine.push(span.textContent);
        });
        if (currentLine.length) lines.push(currentLine);

        lineCount = lines.length;

        // Rebuild heading with line wrappers
        heading.innerHTML = '';
        lines.forEach(function (lineWords, i) {
          var lineEl = document.createElement('span');
          lineEl.className = 'el-hero__heading-line';
          lineEl.style.transitionDelay = (i * 0.12) + 's';
          lineEl.textContent = lineWords.join(' ');
          heading.appendChild(lineEl);
        });
      }

      // Stagger subheading & CTA after the heading lines
      var baseDelay = lineCount * 0.12;
      var sub = hero.querySelector('.el-hero__subheading');
      var cta = hero.querySelector('.el-hero__cta-group');
      if (sub) sub.style.transitionDelay = (baseDelay + 0.08) + 's';
      if (cta) cta.style.transitionDelay = (baseDelay + 0.16) + 's';

      // If no loader, trigger immediately
      if (!document.getElementById('js-loader')) {
        hero.classList.add('is-image-visible');
        hero.classList.add('is-visible');
      }
    })();

    // ── Steps animation — checkmark draw / piechart fill on scroll ──────
    (function () {
      var CIRCLE_APPEAR = 300;
      var CHECK_DELAY = 80;
      var CHECK_DRAW = 250;
      var STEP_GAP = 0;
      var PIE_DURATION = 1200;
      var PIE_STAGGER = 400;

      function easeOutQuartic(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function animatePie(circle, duration) {
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = easeOutQuartic(progress);
          circle.style.setProperty('--fill-progress', eased);

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            circle.style.setProperty('--fill-progress', 1);
          }
        }

        requestAnimationFrame(step);
      }

      document.querySelectorAll('.el-steps--animate').forEach(function (stepsSection) {
        var steps = stepsSection.querySelectorAll('.el-steps__step');
        var isCheckmark = stepsSection.classList.contains('el-steps--checkmark');

        function triggerSteps() {
          stepsSection.classList.add('is-visible');

          if (isCheckmark) {
            var stepDelay = 400;
            steps.forEach(function (stepEl) {
              var circle = stepEl.querySelector('.el-steps__circle');
              if (!circle) return;
              var polyline = circle.querySelector('polyline');

              (function (c, p, delay) {
                setTimeout(function () {
                  c.classList.add('is-circle-visible');
                  if (p) {
                    setTimeout(function () {
                      p.classList.add('is-check-drawn');
                    }, CHECK_DELAY);
                  }
                }, delay);
              })(circle, polyline, stepDelay);

              stepDelay += CIRCLE_APPEAR + CHECK_DELAY + CHECK_DRAW + STEP_GAP;
            });
          } else {
            var pieDelay = 400;
            steps.forEach(function (stepEl, i) {
              var wrap = stepEl.querySelector('.el-steps__circle-wrap');
              var number = stepEl.querySelector('.el-steps__number');
              if (!wrap) return;

              setTimeout(function () {
                animatePie(wrap, PIE_DURATION);
              }, pieDelay + i * PIE_STAGGER);
            });
          }
        }

        var triggered = false;

        function tryTrigger() {
          if (triggered) return;
          triggered = true;
          triggerSteps();
          observer.disconnect();
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) tryTrigger();
          });
        }, { threshold: 0.2 });

        // Defer observing until after loader so elements aren't detected while off-screen
        if (document.getElementById('js-loader')) {
          window.addEventListener('farseer:revealed', function () {
            if (!triggered) observer.observe(stepsSection);
          });
        } else {
          observer.observe(stepsSection);
        }
      });
    })();

    // ── Toggle cards — click to swap problem ⇄ solved (TIC-675) ─────────
    // Each card owns its toggle and its own state; flipping one leaves the
    // others alone, so a visitor can sit a problem card next to a solved one.
    // All the motion lives in CSS — this only flips a class and keeps the
    // button's aria-pressed in step with it.
    (function () {
      document.querySelectorAll('.el-toggle__card--interactive').forEach(function (card) {
        var button = card.querySelector('.el-toggle__toggle');
        if (!button) return;

        // Listen on the card, not the button, so the whole surface flips.
        // A click on the button bubbles up to here, so it still works and
        // still fires exactly once — and the button keeps being the thing
        // keyboard and screen-reader users operate.
        card.addEventListener('click', function (e) {
          // Card copy is wysiwyg, so it can legitimately contain links.
          // Let those navigate instead of swallowing the click.
          if (e.target.closest && e.target.closest('a[href]')) return;

          var solved = card.classList.toggle('is-solved');
          button.setAttribute('aria-pressed', solved ? 'true' : 'false');
        });
      });
    })();

    // ── Toggle animation — slide toggle on scroll ───────────────────────
    // Decorative one-off reveal, unrelated to the click behaviour above. The
    // template drops the `--animate` class when the section is interactive,
    // so the two never drive the same toggle.
    (function () {
      var TOGGLE_STAGGER = 300;

      document.querySelectorAll('.el-toggle--animate').forEach(function (toggleSection) {
        var toggles = toggleSection.querySelectorAll('.el-toggle__toggle');

        var triggered = false;

        function triggerToggles() {
          if (triggered) return;
          triggered = true;
          observer.disconnect();

          toggles.forEach(function (toggle, i) {
            setTimeout(function () {
              toggle.classList.add('is-toggled');
            }, 400 + i * TOGGLE_STAGGER);
          });
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) triggerToggles();
          });
        }, { threshold: 0.2 });

        if (document.getElementById('js-loader')) {
          window.addEventListener('farseer:revealed', function () {
            if (!triggered) observer.observe(toggleSection);
          });
        } else {
          observer.observe(toggleSection);
        }
      });
    })();

    // ── ABC animation — piechart fill on scroll ─────────────────────────
    (function () {
      var PIE_DURATION = 1200;
      var PIE_STAGGER = 400;

      function easeOutQuartic(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function animatePie(el, duration) {
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = easeOutQuartic(progress);
          el.style.setProperty('--fill-progress', eased);

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            el.style.setProperty('--fill-progress', 1);
          }
        }

        requestAnimationFrame(step);
      }

      document.querySelectorAll('.el-abc--animate').forEach(function (abcSection) {
        var rows = abcSection.querySelectorAll('.el-abc__row');

        var triggered = false;

        function triggerAbc() {
          if (triggered) return;
          triggered = true;
          observer.disconnect();

          var pieDelay = 400;
          rows.forEach(function (row, i) {
            var wrap = row.querySelector('.el-abc__circle-wrap');
            if (!wrap) return;

            setTimeout(function () {
              animatePie(wrap, PIE_DURATION);
            }, pieDelay + i * PIE_STAGGER);
          });
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) triggerAbc();
          });
        }, { threshold: 0.2 });

        if (document.getElementById('js-loader')) {
          window.addEventListener('farseer:revealed', function () {
            if (!triggered) observer.observe(abcSection);
          });
        } else {
          observer.observe(abcSection);
        }
      });
    })();

    // ── Cards animation — fill + count-up on scroll ─────────────────────
    (function () {
      var FILL_DURATION = 2000;
      var CARD_STAGGER = 500;

      function easeOutQuartic(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function formatNum(n, isInt) {
        return isInt ? Math.round(n) : n.toFixed(1);
      }

      function animateCount(card, titleEl, duration) {
        var text = (card.getAttribute('data-title') || titleEl.textContent).trim();
        var match = text.match(/^(\d+(?:\.\d+)?)(.*)/);
        if (!match) return;

        var firstNum = parseFloat(match[1]);
        var rest = match[2];
        var isFirstInt = Number.isInteger(firstNum);

        var rangeMatch = rest.match(/^-(\d+(?:\.\d+)?)(.*)/);

        if (rangeMatch) {
          var secondNum = parseFloat(rangeMatch[1]);
          var suffix = rangeMatch[2] || '';
          var isSecondInt = Number.isInteger(secondNum);

          var numSpan = document.createElement('span');
          var rangeSpan = document.createElement('span');
          rangeSpan.className = 'el-cards__card-range';
          var suffixSpan = document.createElement('span');
          suffixSpan.textContent = suffix;

          titleEl.textContent = '';
          titleEl.appendChild(numSpan);
          titleEl.appendChild(rangeSpan);
          titleEl.appendChild(suffixSpan);

          var rangeRevealed = false;
          var startTime = null;

          function rangeStep(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = easeOutQuartic(progress);
            var value = eased * secondNum;

            if (value < firstNum) {
              numSpan.textContent = formatNum(value, isFirstInt);
            } else {
              if (!rangeRevealed) {
                rangeRevealed = true;
                numSpan.textContent = formatNum(firstNum, isFirstInt);
                rangeSpan.classList.add('is-visible');
              }
              rangeSpan.textContent = '-' + formatNum(value, isSecondInt);
            }

            if (progress < 1) {
              requestAnimationFrame(rangeStep);
            } else {
              numSpan.textContent = formatNum(firstNum, isFirstInt);
              rangeSpan.textContent = '-' + formatNum(secondNum, isSecondInt);
              rangeSpan.classList.add('is-visible');
            }
          }

          requestAnimationFrame(rangeStep);

        } else {
          var displaySuffix = rest;
          var numSpan = document.createElement('span');
          titleEl.textContent = '';
          titleEl.appendChild(numSpan);

          var startTime = null;

          function simpleStep(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = easeOutQuartic(progress);
            var current = eased * firstNum;

            numSpan.textContent = formatNum(current, isFirstInt) + displaySuffix;

            if (progress < 1) {
              requestAnimationFrame(simpleStep);
            } else {
              numSpan.textContent = formatNum(firstNum, isFirstInt) + displaySuffix;
            }
          }

          requestAnimationFrame(simpleStep);
        }
      }

      document.querySelectorAll('.el-cards--animate').forEach(function (cardsSection) {
        var cards = cardsSection.querySelectorAll('.el-cards__card');
        if (!cards.length) return;

        function triggerCards() {
          cards.forEach(function (card, i) {
            setTimeout(function () {
              card.classList.add('is-animated');

              var titleEl = card.querySelector('.el-cards__card-title');
              if (titleEl) animateCount(card, titleEl, FILL_DURATION);
            }, i * CARD_STAGGER);
          });
        }

        var triggered = false;

        function tryTrigger() {
          if (triggered) return;
          triggered = true;
          triggerCards();
          observer.disconnect();
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) tryTrigger();
          });
        }, { threshold: 0.2 });

        // Defer observing until after loader so elements aren't detected while off-screen
        if (document.getElementById('js-loader')) {
          window.addEventListener('farseer:revealed', function () {
            if (!triggered) observer.observe(cardsSection);
          });
        } else {
          observer.observe(cardsSection);
        }
      });
    })();

    // ── Admin bar offset — on mobile the WP admin bar scrolls away ──────
    // Track how much of the admin bar is still visible and expose as a CSS
    // custom property so sticky/fixed elements can adjust dynamically.
    if (document.body.classList.contains('admin-bar')) {
      function updateAdminBarOffset() {
        if (window.innerWidth <= 600) {
          // Mobile: admin bar scrolls away — track how much is still visible
          var offset = Math.max(0, 46 - window.scrollY);
          document.documentElement.style.setProperty('--wp-admin-offset', offset + 'px');
        } else if (window.innerWidth <= 782) {
          // Tablet: admin bar is fixed at 46px
          document.documentElement.style.setProperty('--wp-admin-offset', '46px');
        }
      }
      updateAdminBarOffset();
      window.addEventListener('scroll', updateAdminBarOffset, { passive: true });
      window.addEventListener('resize', updateAdminBarOffset, { passive: true });
    }

    // ── Desktop main nav — Apple-style hover behavior ───────────────────
    // Open mega-menus on L1 hover, swap when hovering another L1 with a
    // menu, and only close once the cursor exits the entire header zone.
    // Avoids the "diagonal drift" issue where moving the mouse from a link
    // to the panel grazes a dead pixel and dismisses the dropdown.
    var siteHeader  = document.querySelector('.site-header');
    var primaryList = document.querySelector('.site-nav__list');
    var navOverlay  = document.querySelector('.nav-overlay');

    // Publish the header's actual viewport-relative bottom as a CSS variable
    // so the (fixed-positioned) mega-menu panel and nav-overlay can anchor
    // to wherever the header currently sits. Handles every layout case for
    // free: a promo banner above the header, the WP admin bar offset, and
    // the sticky-stop position once the user has scrolled past the banner.
    if (siteHeader) {
      var headerBottomTicking = false;
      var publishHeaderBottom = function (cachedBottom) {
        // bottom can go negative if the header has scrolled off in static
        // mode; clamp at 0 so the mega-menu doesn't leak above the viewport.
        var bottom = typeof cachedBottom === 'number'
          ? cachedBottom
          : Math.max(0, siteHeader.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--site-header-bottom', bottom + 'px');
      };
      // Throttle to one update per animation frame. Writing this custom
      // property forces a style recalc on every subtree that reads it
      // (mega-menu, nav-overlay); firing on every scroll event in Safari
      // chokes the main thread under fast scroll.
      var onHeaderScroll = function () {
        if (headerBottomTicking) return;
        headerBottomTicking = true;
        requestAnimationFrame(function () {
          headerBottomTicking = false;
          publishHeaderBottom();
        });
      };
      // Initial call uses the batched read from initialLayout (TIC-629) —
      // reading the rect here would force a layout after earlier handlers
      // have already written styles. Event paths read live (the handlers
      // receive an Event object, so the typeof check falls through).
      publishHeaderBottom(initialLayout.headerBottom);
      window.addEventListener('scroll', onHeaderScroll, { passive: true });
      window.addEventListener('resize', publishHeaderBottom);
      window.addEventListener('load', publishHeaderBottom);
    }

    if (siteHeader && primaryList) {
      var topLevelItems = primaryList.querySelectorAll(':scope > li');
      var openHost   = null;
      var closeTimer = null;

      function setOverlay(visible) {
        if (navOverlay) navOverlay.classList.toggle('is-visible', visible);
      }

      // After clicking an L1 link the browser leaves DOM focus on that
      // link, which keeps the host's `:focus-within` rule active and pins
      // its mega-menu open. When the user then mouses to a different L1,
      // the new host gets `.is-open` but the old one stays visible via
      // focus-within — two panels at once. Releasing focus inside the
      // old host on every state change resolves it without sacrificing
      // keyboard accessibility (real keyboard navigation moves focus to
      // a new element first, so the blur is a no-op there).
      function releaseFocusIn(host) {
        if (host && document.activeElement && host.contains(document.activeElement)) {
          document.activeElement.blur();
        }
      }

      function openMega(host) {
        if (openHost === host) return;
        if (openHost) {
          openHost.classList.remove('is-open');
          releaseFocusIn(openHost);
        }
        host.classList.add('is-open');
        openHost = host;
        setOverlay(true);
      }

      function closeMega() {
        if (openHost) {
          openHost.classList.remove('is-open');
          releaseFocusIn(openHost);
        }
        openHost = null;
        setOverlay(false);
      }

      function cancelCloseTimer() {
        if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
      }

      function scheduleClose(delay) {
        cancelCloseTimer();
        closeTimer = window.setTimeout(closeMega, delay);
      }

      topLevelItems.forEach(function (li) {
        var isHost = li.classList.contains('mega-menu-host');
        li.addEventListener('mouseenter', function () {
          cancelCloseTimer();
          if (isHost) {
            openMega(li);
          } else if (openHost) {
            // Hovering an L1 with no mega-menu — close the current one
            // (small grace period for quick passthroughs).
            scheduleClose(120);
          }
        });

        // Mega-menu host L1 links shouldn't navigate on click — the
        // Overview link in the panel footer points to the same URL, so
        // a top-link click is redundant and confusing (the user expects
        // the click to open / keep the panel, not jump away). The href
        // is left in the markup so right-click → "Open in new tab" and
        // search-engine crawling still work; only the default left-click
        // is intercepted. Items without a mega-menu (plain L1 links) are
        // untouched and navigate normally.
        if (isHost) {
          var l1Link = li.querySelector(':scope > a');
          if (l1Link) {
            l1Link.addEventListener('click', function (e) {
              // Allow modifier-clicks (cmd/ctrl/shift/middle) to behave
              // like a normal link so power-users can still open in a
              // new tab/window if they really want to.
              if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
                return;
              }
              e.preventDefault();
              openMega(li);
            });
          }
        }
      });

      // Only a leave from the entire header (or its open panel) closes
      // the menu. Moving sideways between L1 items, or down into the
      // mega-menu, never triggers this — the panel is a descendant of
      // the host <li>, which is inside the header's DOM tree.
      siteHeader.addEventListener('mouseleave', function () {
        if (openHost) scheduleClose(120);
      });

      // Cursor leaving the viewport entirely (URL bar, browser chrome,
      // out the top edge over the WP admin bar, etc.) — close immediately.
      // Browsers don't always fire mouseleave on intermediate elements
      // when the pointer exits the document quickly, so this catches the
      // case where the user shoots up off the page and the header's own
      // mouseleave never gets a chance to run.
      document.documentElement.addEventListener('mouseleave', function () {
        if (openHost) closeMega();
      });
    }

    // ── Mobile menu — toggle & drill-down ───────────────────────────────
    var mobileToggle = document.querySelector('.mobile-menu-toggle');
    var mobileMenu = document.querySelector('.mobile-menu');
    var mobileBody = mobileMenu ? mobileMenu.querySelector('.mobile-menu__body') : null;

    if (mobileToggle && mobileMenu && mobileBody) {
      // Build drill-down panels from WP sub-menus
      var panelStack = [];

      function buildPanels() {
        var items = mobileMenu.querySelectorAll('.mobile-menu__list > .menu-item-has-children');
        items.forEach(function (item) {
          var link = item.querySelector(':scope > a');
          var subMenu = item.querySelector(':scope > .sub-menu');
          if (!link || !subMenu) return;

          // Create panel
          var panel = document.createElement('div');
          panel.className = 'mobile-menu__panel';

          // Back button
          var backBtn = document.createElement('button');
          backBtn.className = 'mobile-menu__panel-header';
          backBtn.textContent = link.textContent.trim();
          backBtn.addEventListener('click', function () {
            panel.classList.remove('is-active');
            panelStack.pop();
          });
          panel.appendChild(backBtn);

          // Move sub-menu items into panel list
          var list = document.createElement('ul');
          list.className = 'mobile-menu__panel-list';
          while (subMenu.firstChild) {
            list.appendChild(subMenu.firstChild);
          }
          panel.appendChild(list);

          mobileBody.appendChild(panel);

          // Make parent link open the panel instead of navigating
          link.addEventListener('click', function (e) {
            e.preventDefault();
            panel.classList.add('is-active');
            panelStack.push(panel);
          });

          // Recursively handle deeper sub-menus within this panel
          var deepItems = list.querySelectorAll('.menu-item-has-children');
          deepItems.forEach(function (deepItem) {
            var deepLink = deepItem.querySelector(':scope > a');
            var deepSub = deepItem.querySelector(':scope > .sub-menu');
            if (!deepLink || !deepSub) return;

            var deepPanel = document.createElement('div');
            deepPanel.className = 'mobile-menu__panel';

            var deepBack = document.createElement('button');
            deepBack.className = 'mobile-menu__panel-header';
            deepBack.textContent = deepLink.textContent.trim();
            deepBack.addEventListener('click', function () {
              deepPanel.classList.remove('is-active');
              panelStack.pop();
            });
            deepPanel.appendChild(deepBack);

            var deepList = document.createElement('ul');
            deepList.className = 'mobile-menu__panel-list';
            while (deepSub.firstChild) {
              deepList.appendChild(deepSub.firstChild);
            }
            deepPanel.appendChild(deepList);

            mobileBody.appendChild(deepPanel);

            deepLink.addEventListener('click', function (e) {
              e.preventDefault();
              deepPanel.classList.add('is-active');
              panelStack.push(deepPanel);
            });
          });
        });
      }

      buildPanels();

      // Toggle open/close (with body scroll lock)
      var savedScrollY = 0;

      mobileToggle.addEventListener('click', function () {
        var isOpen = document.body.classList.toggle('mobile-menu-open');
        mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        if (isOpen) {
          savedScrollY = window.scrollY;
          document.body.style.top = -savedScrollY + 'px';
        } else {
          document.body.style.top = '';
          window.scrollTo(0, savedScrollY);
          // Close all panels when menu closes
          panelStack.forEach(function (p) { p.classList.remove('is-active'); });
          panelStack = [];
        }
      });

      // Auto-close mobile menu when resizing past desktop breakpoint
      var desktopMQ = window.matchMedia('(min-width: 880px)');
      desktopMQ.addEventListener('change', function (e) {
        if (e.matches && document.body.classList.contains('mobile-menu-open')) {
          document.body.classList.remove('mobile-menu-open');
          mobileToggle.setAttribute('aria-expanded', 'false');
          mobileMenu.setAttribute('aria-hidden', 'true');
          document.body.style.top = '';
          window.scrollTo(0, savedScrollY);
          panelStack.forEach(function (p) { p.classList.remove('is-active'); });
          panelStack = [];
        }
      });
    }



    // ── Quote with Cards — tab switching ──────────────────────────────────────
    document.querySelectorAll('.el-testimonials').forEach(function (section) {
      var tabs = section.querySelectorAll('.el-testimonials__tab');
      var panels = section.querySelectorAll('.el-testimonials__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function (p) {
            if (p.getAttribute('data-panel') === target) {
              p.classList.add('is-active');
              p.removeAttribute('hidden');
            } else {
              p.classList.remove('is-active');
              p.setAttribute('hidden', '');
            }
          });
        });
      });
    });

    // ── Quotes carousel ───────────────────────────────────────────────────
    document.querySelectorAll('.el-quotes--carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.el-quotes__track');
      var slides = track ? track.querySelectorAll('.el-quotes__slide') : [];
      var total = slides.length;
      if (total < 2) return;

      var currentSpans = carousel.querySelectorAll('.el-quotes__current');
      var prevBtns = carousel.querySelectorAll('.el-quotes__btn--prev');
      var nextBtns = carousel.querySelectorAll('.el-quotes__btn--next');

      var currentIndex = 0;

      function showSlide(index) {
        currentIndex = (index + total) % total;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('hidden', i !== currentIndex);
        });
        currentSpans.forEach(function (span) {
          span.textContent = String(currentIndex + 1).padStart(2, '0');
        });
      }

      prevBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          showSlide(currentIndex - 1);
        });
      });
      nextBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          showSlide(currentIndex + 1);
        });
      });

      showSlide(0);
    });

    // ── Slider — scrollbar sync & click-to-scroll ─────────────────────────
    document.querySelectorAll('.el-slider').forEach(function (section) {
      if (section.classList.contains('el-slider--grid')) return;
      var track = section.querySelector('.el-slider__track');
      var nav = section.querySelector('.el-slider__nav');
      var prevBtn = section.querySelector('.el-slider__nav-btn--prev');
      var nextBtn = section.querySelector('.el-slider__nav-btn--next');
      if (!track) return;

      function getCardWidth() {
        var card = track.querySelector('.el-slider__card');
        if (!card) return 300;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 0;
        return card.offsetWidth + gap;
      }

      function updateNavVisibility() {
        if (!nav) return;
        var isScrollable;
        // First call consumes the batched read from initialLayout (TIC-629)
        // so init doesn't force a layout; resize/ResizeObserver paths
        // re-measure live after the cache entry is spent.
        if (initialLayout.sliderScrollable.has(track)) {
          isScrollable = initialLayout.sliderScrollable.get(track);
          initialLayout.sliderScrollable.delete(track);
        } else {
          isScrollable = track.scrollWidth > track.clientWidth + 1;
        }
        nav.style.display = isScrollable ? '' : 'none';
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
        });
      }

      updateNavVisibility();
      window.addEventListener('resize', updateNavVisibility);
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(updateNavVisibility);
        ro.observe(track);
      }
    });

    // ── Slider title overflow — scroll title in sync with track ────────────
    document.querySelectorAll('.el-slider--title-overflow').forEach(function (section) {
      var title = section.querySelector('.el-slider__title--extra-large');
      var track = section.querySelector('.el-slider__track');
      if (!title || !track) return;

      function syncTitle() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) { title.style.transform = ''; return; }
        var progress = track.scrollLeft / maxScroll;
        var wrapper = title.parentElement;
        var titleOverflow = title.scrollWidth - wrapper.clientWidth;
        if (titleOverflow <= 0) { title.style.transform = ''; return; }
        // Account for left padding offset + right inset so the title's
        // right edge aligns with the last card's right edge.
        var pad = parseFloat(getComputedStyle(wrapper).paddingLeft) || 0;
        title.style.transform = 'translateX(' + (-progress * (titleOverflow + pad * 2)) + 'px)';
      }

      track.addEventListener('scroll', syncTitle, { passive: true });
      window.addEventListener('resize', syncTitle);
      syncTitle();
    });

    // ── Brand Cards Slider — auto-playing + swipe/drag ─────────────────────
    document.querySelectorAll('[data-el-brand-cards-slider]').forEach(function (section) {
      var viewport = section.querySelector('.el-brand-cards-slider__viewport');
      var track = section.querySelector('.el-brand-cards-slider__track');
      var slides = track ? track.querySelectorAll('.el-brand-cards-slider__slide') : [];
      var totalSlides = slides.length;
      var speedSec = parseInt(section.getAttribute('data-speed'), 10) || 5;
      var cardCount = parseInt(section.getAttribute('data-count'), 10) || Math.ceil(totalSlides / 2);
      if (totalSlides < 2 || cardCount < 1) return;

      var currentIndex = 0;
      var isDragging = false;
      var startX = 0;
      var baseOffset = 0;

      function getStep() {
        var first = slides[0];
        if (!first) return { slideWidth: 0, gap: 0 };
        var slideWidth = first.offsetWidth;
        var gap = parseFloat(getComputedStyle(track).gap) || 15;
        return { slideWidth: slideWidth, gap: gap };
      }

      function getSpacerWidth() {
        return window.innerWidth <= 767 ? 0 : 30;
      }

      function applyTransform(noTransition, dragPx) {
        var step = getStep();
        if (!step.slideWidth) return;
        var offset = getSpacerWidth() + currentIndex * (step.slideWidth + step.gap);
        if (dragPx !== undefined) {
          offset = offset - dragPx;
        }
        if (noTransition) {
          track.style.transition = 'none';
        }
        track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
        if (noTransition && dragPx === undefined) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              track.style.transition = '';
            });
          });
        }
      }

      function goNext() {
        currentIndex = (currentIndex + 1) % totalSlides;
        applyTransform(false);
        if (currentIndex === cardCount) {
          track.addEventListener('transitionend', function onEnd() {
            track.removeEventListener('transitionend', onEnd);
            currentIndex = 0;
            applyTransform(true);
          }, { once: true });
        }
      }

      function goPrev() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        applyTransform(false);
      }

      function startTimer() {
        return setInterval(goNext, speedSec * 1000);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      applyTransform(true);
      var timer = startTimer();

      section.addEventListener('mouseenter', function () {
        stopTimer();
      });
      section.addEventListener('mouseleave', function () {
        timer = startTimer();
      });

      if (viewport) {
        var threshold = 40;

        function getClientX(e) {
          if (e.touches && e.touches.length) return e.touches[0].clientX;
          if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
          return e.clientX;
        }

        function onStart(e) {
          if (isDragging) return;
          isDragging = true;
          e.preventDefault();
          stopTimer();
          startX = getClientX(e);
          var step = getStep();
          baseOffset = getSpacerWidth() + currentIndex * (step.slideWidth + step.gap);
          track.style.transition = 'none';
          if (viewport.setPointerCapture && e.pointerId !== undefined) {
            viewport.setPointerCapture(e.pointerId);
          }
        }

        function onMove(e) {
          if (!isDragging) return;
          e.preventDefault();
          var x = getClientX(e);
          var deltaX = x - startX;
          applyTransform(true, deltaX);
        }

        function onEnd(e) {
          if (!isDragging) return;
          isDragging = false;
          track.style.transition = '';
          if (viewport.releasePointerCapture && e.pointerId !== undefined) {
            viewport.releasePointerCapture(e.pointerId);
          }
          var x = getClientX(e);
          var deltaX = x - startX;
          var step = getStep();
          if (deltaX > threshold) {
            goPrev();
          } else if (deltaX < -threshold) {
            goNext();
            if (currentIndex === cardCount) {
              track.addEventListener('transitionend', function onEnd() {
                track.removeEventListener('transitionend', onEnd);
                currentIndex = 0;
                applyTransform(true);
              }, { once: true });
            }
          } else {
            applyTransform(false);
          }
          timer = startTimer();
        }

        viewport.addEventListener('pointerdown', onStart, { passive: false });
        viewport.addEventListener('pointermove', onMove, { passive: false });
        viewport.addEventListener('pointerup', onEnd, { passive: true });
        viewport.addEventListener('pointercancel', onEnd, { passive: true });
      }

      window.addEventListener('resize', function () {
        applyTransform(true);
      });
    });

    // ── Video section — play/pause, oEmbed reveal, volume ─────────────────
    document.querySelectorAll('[data-el-video]').forEach(function (player) {
      var section = player.closest('.el-video');
      var playBtn = player.querySelector('[data-el-video-play]');
      var poster = player.querySelector('[data-el-video-poster]');
      var video = player.querySelector('.el-video__video');
      var embedWrap = player.querySelector('.el-video__embed');
      var controls = player.querySelector('[data-el-video-controls]');
      var toggleBtn = player.querySelector('[data-el-video-toggle]');
      var volumeBtn = player.querySelector('[data-el-video-volume]');

      if (!section || !playBtn) return;

      // Controls overlays (poster, big play button, embed visibility)
      function setOverlayActive(active) {
        section.classList.toggle('is-playing', active);
        if (embedWrap) {
          embedWrap.classList.toggle('is-hidden', !active);
          embedWrap.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) {
            var iframe = embedWrap.querySelector('iframe');
            if (iframe && iframe.src && iframe.src.indexOf('autoplay') === -1) {
              iframe.src = iframe.src + (iframe.src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';
            }
          }
        }
        if (controls) {
          controls.classList.toggle('is-hidden', !active || !video);
          controls.setAttribute('aria-hidden', active && video ? 'false' : 'true');
        }
      }

      // Updates only the play/pause icon and label, without changing overlays
      function setIconPlaying(playing) {
        if (video && toggleBtn) {
          toggleBtn.classList.toggle('is-paused', !playing);
          toggleBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
        }
      }

      playBtn.addEventListener('click', function () {
        if (video) {
          video.play();
        }
        setOverlayActive(true);
      });

      if (video && toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      }

      if (video) {
        video.addEventListener('play', function () {
          setOverlayActive(true);
          setIconPlaying(true);
        });
        video.addEventListener('pause', function () {
          // Pause should not reset overlays to poster; only switch the icon.
          setIconPlaying(false);
        });
        video.addEventListener('ended', function () {
          // When video ends, reset to initial state.
          setIconPlaying(false);
          setOverlayActive(false);
        });
      }

      if (video && volumeBtn) {
        volumeBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          volumeBtn.classList.toggle('is-muted', video.muted);
          volumeBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        });
      }
    });

    // ── Tabs + content — vertical tabs switching, autoplay, indicator animation ─
    document.querySelectorAll('[data-el-tabs]').forEach(function (section) {
      var triggers = section.querySelectorAll('[data-el-tabs-trigger]');
      var panels = section.querySelectorAll('[data-el-tabs-panel]');
      var select = section.querySelector('[data-el-tabs-select]');
      var prevBtn = section.querySelector('[data-el-tabs-prev]');
      var nextBtn = section.querySelector('[data-el-tabs-next]');
      var currentEl = section.querySelector('[data-el-tabs-current]');
      var card = section.querySelector('.el-tabs-with-content__panel-card');
      var intervalSec = parseInt(section.getAttribute('data-el-tabs-interval'), 10) || 0;
      var autoplayTimer = null;
      var activeIndex = 0;

      if (!triggers.length || !panels.length) return;

      if (intervalSec > 0) {
        section.classList.add('el-tabs-with-content--autoplay');
      }

      function startIndicatorAnimation(trigger, durationSec) {
        var indicator = trigger && trigger.querySelector('.el-tabs-with-content__tab-indicator');
        if (!indicator) return;
        indicator.style.animation = 'none';
        indicator.offsetHeight;
        indicator.style.animation = 'el-tabs-indicator-fill ' + durationSec + 's linear forwards';
      }

      function resetIndicator(trigger) {
        var indicator = trigger && trigger.querySelector('.el-tabs-with-content__tab-indicator');
        if (!indicator) return;
        indicator.style.animation = 'none';
        indicator.style.width = '0';
      }

      function activate(index) {
        index = parseInt(index, 10);
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }

        triggers.forEach(function (btn) {
          var i = parseInt(btn.getAttribute('data-el-tabs-trigger'), 10);
          var isActive = index === i;
          btn.classList.toggle('el-tabs-with-content__tab--active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive && intervalSec > 0) {
            startIndicatorAnimation(btn, intervalSec);
          } else if (isActive && intervalSec === 0) {
            var ind = btn.querySelector('.el-tabs-with-content__tab-indicator');
            if (ind) {
              ind.style.animation = 'none';
              ind.style.width = '';
            }
          } else {
            resetIndicator(btn);
          }
        });

        panels.forEach(function (panel) {
          var i = parseInt(panel.getAttribute('data-el-tabs-panel'), 10);
          var isActive = index === i;
          panel.classList.toggle('el-tabs-with-content__panel--active', isActive);
        });

        if (select) {
          select.value = String(index);
        }

        activeIndex = index;
        if (currentEl) {
          currentEl.textContent = String(index + 1).padStart(2, '0');
        }

        if (intervalSec > 0 && triggers.length > 1) {
          var nextIndex = (index + 1) % triggers.length;
          autoplayTimer = setTimeout(function () {
            activate(nextIndex);
          }, intervalSec * 1000);
        }
      }

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-el-tabs-trigger');
          activate(idx);
        });
      });

      if (select) {
        select.addEventListener('change', function () {
          activate(select.value);
        });
      }

      // Prev / next arrow buttons (mobile)
      function step(delta) {
        var n = triggers.length;
        var next = (activeIndex + delta + n) % n;
        activate(next);
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

      // Horizontal swipe on the panel card (mobile)
      if (card) {
        var touchStartX = 0;
        var touchStartY = 0;
        var touchTracking = false;
        var swipeThreshold = 30; // px

        card.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchTracking = true;
        }, { passive: true });

        card.addEventListener('touchend', function (e) {
          if (!touchTracking) return;
          touchTracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - touchStartX;
          var dy = t.clientY - touchStartY;
          // Horizontal swipe only (ignore mostly-vertical movement)
          if (Math.abs(dx) > swipeThreshold && Math.abs(dx) > Math.abs(dy)) {
            step(dx < 0 ? 1 : -1);
          }
        }, { passive: true });

        card.addEventListener('touchcancel', function () { touchTracking = false; });
      }

      if (intervalSec > 0) {
        activate(0);
      }
    });

    // ── Logo Stripe — drag-to-scroll ───────────────────────────────────────
    document.querySelectorAll('.el-logo-stripe__track').forEach(function (track) {
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;

      track.addEventListener('pointerdown', function (e) {
        isDragging = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.setPointerCapture(e.pointerId);
        track.style.cursor = 'grabbing';
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        track.scrollLeft = startScroll - (e.clientX - startX);
      });

      track.addEventListener('pointerup', function (e) {
        isDragging = false;
        track.style.cursor = '';
      });

      track.addEventListener('pointercancel', function () {
        isDragging = false;
        track.style.cursor = '';
      });
    });

    // ── FAQ accordion ─────────────────────────────────────────────────────
    document.querySelectorAll('.el-faq').forEach(function (section) {
      var items = section.querySelectorAll('.el-faq__item');

      function finishItem(item) {
        var answer = item.querySelector('.el-faq__answer');
        if (!answer) return;
        item.classList.remove('is-animating', 'is-closing');
        answer.style.height = '';
        answer.style.overflow = '';
      }

      function closeItem(item, cb) {
        var trigger = item.querySelector('.el-faq__trigger');
        var answer = item.querySelector('.el-faq__answer');
        if (!answer || !item.classList.contains('is-open')) { if (cb) cb(); return; }

        finishItem(item);
        item.classList.add('is-closing', 'is-animating');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        answer.style.height = answer.scrollHeight + 'px';
        answer.style.overflow = 'hidden';

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            answer.style.height = '0';
            answer.addEventListener('transitionend', function onEnd() {
              answer.removeEventListener('transitionend', onEnd);
              item.classList.remove('is-open', 'is-closing', 'is-animating');
              answer.style.height = '';
              answer.style.overflow = '';
              if (cb) cb();
            }, { once: true });
          });
        });
      }

      function openItem(item) {
        var trigger = item.querySelector('.el-faq__trigger');
        var answer = item.querySelector('.el-faq__answer');
        if (!answer || item.classList.contains('is-open')) return;

        finishItem(item);
        item.classList.add('is-open', 'is-animating');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var targetHeight = answer.scrollHeight;
        answer.style.height = '0';
        answer.style.overflow = 'hidden';

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            answer.style.height = targetHeight + 'px';
            answer.addEventListener('transitionend', function onEnd() {
              answer.removeEventListener('transitionend', onEnd);
              item.classList.remove('is-animating');
              answer.style.height = '';
              answer.style.overflow = '';
            }, { once: true });
          });
        });
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('.el-faq__trigger');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          if (item.classList.contains('is-animating')) return;

          var isOpen = item.classList.contains('is-open');

          // Close all other open items
          items.forEach(function (other) {
            if (other !== item && other.classList.contains('is-open')) {
              closeItem(other);
            }
          });

          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });
    });

  });

  // ==========================================================================
  // Comparison Table — expandable row toggle
  // ==========================================================================
  document.querySelectorAll('.el-comparison').forEach(function (section) {
    var triggers = section.querySelectorAll('.el-comparison__row-trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var row = trigger.closest('.el-comparison__row');
        if (!row) return;
        var willOpen = !row.classList.contains('is-open');
        row.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  });

  // ==========================================================================
  // Article Video — YouTube lite embed (loads iframe on click)
  // ==========================================================================
  document.querySelectorAll('[data-art-video-yt]').forEach(function (player) {
    var videoId = player.dataset.artVideoYt;
    var title   = player.dataset.title || 'YouTube video';
    var captions = player.dataset.artVideoCc !== '0'; // default on
    var playBtn = player.querySelector('.art-video__play');
    if (!playBtn || !videoId) return;

    function loadVideo() {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0' + (captions ? '&cc_load_policy=1' : '');
      iframe.title = title;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      player.appendChild(iframe);
      player.classList.add('is-playing');
    }

    playBtn.addEventListener('click', loadVideo);
  });

  // ==========================================================================
  // WordPress Form — AJAX submission (with optional reCAPTCHA v3)
  // ==========================================================================
  document.querySelectorAll('.el-wp-form__form').forEach(function (form) {
    var submitting = false;

    // Clear error state on user input.
    form.addEventListener('input', function (evt) {
      var field = evt.target.closest('.el-wp-form__field');
      if (field) field.classList.remove('el-wp-form__field-error');
    });
    form.addEventListener('change', function (evt) {
      var consent = evt.target.closest('.el-wp-form__consent');
      if (consent) consent.classList.remove('el-wp-form__field-error');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;

      // --- Client-side validation ---
      var inputs = form.querySelectorAll('input[name], select[name], textarea[name]');
      var valid = true;

      // Clear previous errors.
      form.querySelectorAll('.el-wp-form__field-error')
        .forEach(function (el) { el.classList.remove('el-wp-form__field-error'); });

      inputs.forEach(function (inp) {
        // Consent checkbox.
        if (inp.type === 'checkbox') {
          if (inp.required && !inp.checked) {
            valid = false;
            var wrap = inp.closest('.el-wp-form__consent');
            if (wrap) wrap.classList.add('el-wp-form__field-error');
          }
          return;
        }

        // Skip hidden fields.
        if (inp.type === 'hidden') return;

        // Required check.
        if (inp.required && !inp.value.trim()) {
          valid = false;
          var field = inp.closest('.el-wp-form__field');
          if (field) field.classList.add('el-wp-form__field-error');
        }
        // Email format check.
        else if (inp.type === 'email' && inp.value.trim() && !inp.validity.valid) {
          valid = false;
          var field = inp.closest('.el-wp-form__field');
          if (field) field.classList.add('el-wp-form__field-error');
        }
      });

      if (!valid) {
        var firstErr = form.querySelector('.el-wp-form__field-error');
        if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      submitting = true;

      var formWrap = form.closest('.el-wp-form__form-wrap');
      var confirmEl = formWrap.querySelector('.el-wp-form__confirmation');
      var submitBtn = form.querySelector('.el-wp-form__submit');
      var msgEl = form.querySelector('.el-wp-form__message');
      var ajaxUrl = form.dataset.ajaxUrl;
      var successHeading = form.dataset.successHeading;
      var successMsg = form.dataset.success;
      var errorMsg = form.dataset.error;
      var recaptchaKey = form.dataset.recaptchaKey;
      var originalHTML = submitBtn.innerHTML;

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending\u2026';
      msgEl.hidden = true;

      function showError(text) {
        msgEl.textContent = text;
        msgEl.className = 'el-wp-form__message el-wp-form__message--error';
        msgEl.hidden = false;
        msgEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      function showConfirmation() {
        // Collect field values BEFORE hiding the form.
        var dlEvent = form.dataset.dlEvent;
        var dlData = null;
        if (dlEvent && window.dataLayer) {
          dlData = { event: dlEvent };
          if (form.dataset.dlFormName) {
            dlData.form_name = form.dataset.dlFormName;
          }
          form.querySelectorAll('input[name^="fields["], textarea[name^="fields["], select[name^="fields["]').forEach(function (inp) {
            var match = inp.name.match(/^fields\[(.+)\]$/);
            if (match) {
              dlData[match[1]] = inp.value;
            }
          });
        }

        confirmEl.querySelector('.el-wp-form__confirm-heading').textContent = successHeading;
        confirmEl.querySelector('.el-wp-form__confirm-text').textContent = successMsg;
        form.hidden = true;
        confirmEl.hidden = false;
        confirmEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (dlData) {
          window.dataLayer.push(dlData);
        }
      }

      function submitForm(token) {
        var formData = new FormData(form);
        if (token) {
          formData.append('recaptcha_token', token);
        }

        fetch(ajaxUrl, {
          method: 'POST',
          body: formData,
        })
          .then(function (res) { return res.json(); })
          .then(function (json) {
            if (json.success) {
              showConfirmation();
            } else {
              showError(json.data || errorMsg);
            }
          })
          .catch(function () {
            showError(errorMsg);
          })
          .finally(function () {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalHTML;
            submitting = false;
          });
      }

      // If reCAPTCHA is configured, get a token first
      if (recaptchaKey && window.grecaptcha) {
        window.grecaptcha.ready(function () {
          window.grecaptcha.execute(recaptchaKey, { action: 'farseer_wp_form' })
            .then(submitForm)
            .catch(function () { submitForm(''); });
        });
      } else {
        submitForm('');
      }
    });
  });

  // ==========================================================================
  // HubSpot Meeting — 3-step: calendar → form → confirmation
  // ==========================================================================
  document.querySelectorAll('[data-hs-meeting]').forEach(function (section) {
    var slug        = section.dataset.slug;
    var ajaxUrl     = section.dataset.ajaxUrl;
    var nonce       = section.dataset.nonce;
    var errorMsg    = section.dataset.errorMsg;
    var noAvailMsg  = section.dataset.noAvailMsg;
    var successHd   = section.dataset.successHeading;
    var successMsg  = section.dataset.successMsg;
    var dlFormName  = section.dataset.dlFormName || '';
    var partialForm = section.dataset.partialForm || ''; // portalId:formGuid for TIC-567 partial capture

    // Map HubSpot field names → dataLayer parameter names.
    var dlFieldMap = {
      firstName: 'first_name',
      lastName: 'last_name',
      email: 'email',
      company: 'company_name',
      role_in_the_company: 'role',
      country: 'country_free_entry'
    };

    function dlPush(eventName) {
      if (!dlFormName || !window.dataLayer) return;
      var data = { event: eventName, form_name: dlFormName };
      if (state.formData) {
        Object.keys(state.formData).forEach(function (k) {
          var mapped = dlFieldMap[k] || k;
          data[mapped] = state.formData[k];
        });
      }
      window.dataLayer.push(data);
    }

    // DOM refs — Step 1 (form)
    var panels        = section.querySelectorAll('.el-hs-meeting__panel');
    var form          = section.querySelector('.el-hs-meeting__form');
    var formFieldsEl  = section.querySelector('.el-hs-meeting__form-fields');
    var loadingEl     = section.querySelector('.el-hs-meeting__loading');

    // DOM refs — Step 2 (calendar)
    var durationsEl = section.querySelector('.el-hs-meeting__durations');
    var calTitle    = section.querySelector('.el-hs-meeting__cal-title');
    var calWeekdays = section.querySelector('.el-hs-meeting__cal-weekdays');
    var calDays     = section.querySelector('.el-hs-meeting__cal-days');
    var calPrev     = section.querySelector('.el-hs-meeting__cal-prev');
    var calNext     = section.querySelector('.el-hs-meeting__cal-next');
    var noAvailEl   = section.querySelector('.el-hs-meeting__no-avail');
    var timesWrap   = section.querySelector('.el-hs-meeting__times');
    var timesHead   = section.querySelector('.el-hs-meeting__times-heading');
    var timesList   = section.querySelector('.el-hs-meeting__times-list');
    var bookBtn     = section.querySelector('.el-hs-meeting__btn--book');
    var backLink    = section.querySelector('.el-hs-meeting__back-link');
    var calLoadingEl = section.querySelector('.el-hs-meeting__loading--cal');

    // DOM refs — Step 3 (confirmation)
    var confirmHead = section.querySelector('.el-hs-meeting__confirm-heading');
    var confirmText = section.querySelector('.el-hs-meeting__confirm-text');
    var confirmDets = section.querySelector('.el-hs-meeting__confirm-details');
    var msgEl       = section.querySelector('.el-hs-meeting__message');

    // State
    var state = {
      step: 1,
      tz: (Intl.DateTimeFormat().resolvedOptions().timeZone) || 'UTC',
      locale: navigator.language || 'en',
      durations: [], selectedDuration: null,
      slotsByDate: {},
      formFields: [],
      viewYear: new Date().getFullYear(),
      viewMonth: new Date().getMonth(),
      selectedDate: null, selectedSlot: null,
      dataLoaded: false
    };

    // ── Helpers ────────────────────────────────────────────────────
    function dateKey(epochMs) {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: state.tz, year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date(epochMs));
    }

    function formatTime(epochMs) {
      return new Intl.DateTimeFormat(state.locale, {
        timeZone: state.tz, hour: 'numeric', minute: '2-digit'
      }).format(new Date(epochMs));
    }

    function formatDateLong(epochMs) {
      return new Intl.DateTimeFormat(state.locale, {
        timeZone: state.tz, weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
        hour: 'numeric', minute: '2-digit'
      }).format(new Date(epochMs));
    }

    function formatDateShort(dateStr) {
      var p = dateStr.split('-');
      return new Intl.DateTimeFormat(state.locale, {
        timeZone: state.tz, weekday: 'long', month: 'long', day: 'numeric'
      }).format(new Date(+p[0], +p[1] - 1, +p[2]));
    }

    function showMsg(text, type) {
      msgEl.textContent = text;
      msgEl.className = 'el-hs-meeting__message el-hs-meeting__message--' + type;
      msgEl.hidden = false;
    }
    function hideMsg() { msgEl.hidden = true; }
    function setLoading(on) { loadingEl.hidden = !on; }
    function setCalLoading(on) { if (calLoadingEl) calLoadingEl.hidden = !on; }

    function post(action, data) {
      var fd = new FormData();
      fd.append('action', action);
      fd.append('nonce', nonce);
      Object.keys(data).forEach(function (k) {
        var v = data[k];
        if (Array.isArray(v)) {
          v.forEach(function (item) { fd.append(k + '[]', item); });
        } else {
          fd.append(k, v);
        }
      });
      return fetch(ajaxUrl, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); });
    }

    function goToStep(n) {
      state.step = n;
      panels.forEach(function (p) {
        p.classList.toggle('is-active', +p.dataset.panel === n);
      });
      // Step 2 expands the widget to full width and fades out the sidebar.
      section.classList.toggle('el-hs-meeting--full-width', n === 2);
      hideMsg();
      var header = document.querySelector('.site-header');
      var offset = (header ? header.offsetHeight : 0) + 20;
      var top = section.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // ── Fetch meeting config (on page load) ───────────────────────
    function fetchMeetingConfig() {
      setLoading(true);
      post('farseer_hubspot_meeting_availability', {
        slug: slug, timezone: state.tz, monthOffset: 0
      }).then(function (json) {
        if (!json.success) { showMsg(json.data || errorMsg, 'error'); return; }
        var d = json.data;
        state.dataLoaded = true;

        // Durations
        state.durations = (d.customParams && d.customParams.durations) || [];
        if (!state.selectedDuration && state.durations.length) {
          state.selectedDuration = state.durations[0];
        }

        // Form fields from API
        state.formFields = (d.customParams && d.customParams.formFields) || [];

        // Availability (pre-load for step 2)
        parseAvailability(d.linkAvailability);

        // Render the form (step 1)
        renderFormStep();
      }).catch(function () {
        showMsg(errorMsg, 'error');
      }).finally(function () {
        setLoading(false);
      });
    }

    function parseAvailability(linkAvail) {
      if (!linkAvail || !linkAvail.linkAvailabilityByDuration) return;
      var byDur = linkAvail.linkAvailabilityByDuration;
      Object.keys(byDur).forEach(function (durKey) {
        var slots = byDur[durKey].availabilities || [];
        slots.forEach(function (slot) {
          var key = dateKey(slot.startMillisUtc);
          if (!state.slotsByDate[key]) state.slotsByDate[key] = [];
          var exists = state.slotsByDate[key].some(function (s) { return s.start === slot.startMillisUtc; });
          if (!exists) {
            state.slotsByDate[key].push({ start: slot.startMillisUtc, end: slot.endMillisUtc, duration: +durKey });
          }
        });
      });
    }

    function getSlotsForDay(key) {
      var all = state.slotsByDate[key] || [];
      if (!state.selectedDuration) return all;
      return all.filter(function (s) { return s.duration === state.selectedDuration; });
    }

    // Find the earliest date (>= today) that has available slots.
    function findFirstAvailableDate() {
      var now = new Date();
      var todayKey = dateKey(now.getTime());
      var keys = Object.keys(state.slotsByDate).sort();
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] < todayKey) continue;
        if (getSlotsForDay(keys[i]).length > 0) return keys[i];
      }
      return null;
    }

    // ── Fetch additional months from HubSpot's public API (browser-side) ──
    var fetchedPublicOffsets = {};

    // HubSpot shards portals across regional "hublets". Month 0 comes from our
    // server-side proxy, which HubSpot routes by the OAuth token, so it is
    // unaffected. Later months use the *unauthenticated* public meetings API,
    // which has no token to route by: calling the default US host for a
    // non-US portal answers 488 "Link is in different hublet". This portal is
    // eu1, so start there — the 488 handler below still corrects it either way.
    var publicApiHublet = 'eu1';

    function publicMonthUrl(offset, hublet) {
      var host = hublet ? 'api-' + hublet + '.hubspot.com' : 'api.hubspot.com';
      return 'https://' + host + '/meetings-public/v3/book/availability-page'
           + '?slug=' + encodeURIComponent(slug)
           + '&timezone=' + encodeURIComponent(state.tz)
           + '&monthOffset=' + offset;
    }

    function fetchPublicMonth(year, month) {
      var now = new Date();
      var offset = (year - now.getFullYear()) * 12 + (month - now.getMonth());
      if (offset <= 0 || fetchedPublicOffsets[offset]) return;

      // Check if we already have slots for this month
      var monthKey = year + '-' + String(month + 1).padStart(2, '0');
      var hasData = Object.keys(state.slotsByDate).some(function (k) {
        return k.indexOf(monthKey) === 0;
      });
      if (hasData) return;

      fetchedPublicOffsets[offset] = true;
      setCalLoading(true);

      var attempted = false;

      function attempt(hublet) {
        return fetch(publicMonthUrl(offset, hublet))
          .then(function (res) { return res.json(); })
          .then(function (data) {
            // HTTP 488 — the portal lives in another hublet and this endpoint
            // is unauthenticated, so HubSpot has no token to route by. The
            // body names the right one, so retry there once and remember it,
            // which means a future portal migration fixes itself.
            if (data && data.correctHublet && data.correctHublet !== hublet && !attempted) {
              attempted = true;
              publicApiHublet = data.correctHublet;
              return attempt(publicApiHublet);
            }
            return data;
          });
      }

      attempt(publicApiHublet)
        .then(function (data) {
          if (data && data.linkAvailability) {
            parseAvailability(data.linkAvailability);
            if (state.step === 2) renderCalendar();
            return;
          }
          // Nothing usable came back. Release the offset so the month can be
          // fetched again — caching the miss is what turned a transient
          // failure into a permanent "No available times for this period".
          fetchedPublicOffsets[offset] = false;
        })
        .catch(function () {
          fetchedPublicOffsets[offset] = false;
        })
        .finally(function () { setCalLoading(false); });
    }

    // ── Duration selector ──────────────────────────────────────────
    function renderDurations() {
      if (state.durations.length <= 1) { durationsEl.hidden = true; return; }
      durationsEl.hidden = false;
      durationsEl.innerHTML = '';
      state.durations.forEach(function (ms) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'el-hs-meeting__duration-btn' + (ms === state.selectedDuration ? ' is-selected' : '');
        btn.textContent = (ms / 60000) + ' min';
        btn.addEventListener('click', function () {
          state.selectedDuration = ms;
          state.selectedDate = null;
          state.selectedSlot = null;
          bookBtn.disabled = true;
          timesWrap.hidden = true;
          renderDurations();
          renderCalendar();
        });
        durationsEl.appendChild(btn);
      });
    }

    // ── Calendar ───────────────────────────────────────────────────
    function renderCalendar() {
      var year = state.viewYear, month = state.viewMonth;
      var now = new Date();
      var todayKey = dateKey(now.getTime());

      calTitle.textContent = new Intl.DateTimeFormat(state.locale, { month: 'long', year: 'numeric' })
        .format(new Date(year, month, 1));

      if (!calWeekdays.children.length) {
        ['MON','TUE','WED','THU','FRI','SAT','SUN'].forEach(function (d) {
          var s = document.createElement('span'); s.textContent = d; calWeekdays.appendChild(s);
        });
      }

      calDays.innerHTML = '';
      var firstDay = new Date(year, month, 1).getDay();
      var blanks = (firstDay + 6) % 7;
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var hasAny = false;

      for (var b = 0; b < blanks; b++) {
        var bl = document.createElement('span');
        bl.className = 'el-hs-meeting__cal-day el-hs-meeting__cal-day--empty';
        calDays.appendChild(bl);
      }

      for (var d = 1; d <= daysInMonth; d++) {
        var key = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
        var slots = getSlotsForDay(key);
        var isPast = new Date(year, month, d, 23, 59, 59) < now;
        var isAvail = slots.length > 0 && !isPast;
        if (isAvail) hasAny = true;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = d;
        btn.className = 'el-hs-meeting__cal-day';
        if (isAvail) btn.className += ' el-hs-meeting__cal-day--available';
        if (isPast || !isAvail) { btn.className += ' el-hs-meeting__cal-day--disabled'; btn.disabled = true; }
        if (key === todayKey) btn.className += ' el-hs-meeting__cal-day--today';
        if (state.selectedDate === key) btn.className += ' is-selected';

        (function (k) { btn.addEventListener('click', function () { selectDate(k); }); })(key);
        calDays.appendChild(btn);
      }

      // Pad trailing empty cells to complete the last row
      var totalCells = blanks + daysInMonth;
      var trailing = (7 - (totalCells % 7)) % 7;
      for (var t = 0; t < trailing; t++) {
        var te = document.createElement('span');
        te.className = 'el-hs-meeting__cal-day el-hs-meeting__cal-day--empty';
        calDays.appendChild(te);
      }

      noAvailEl.hidden = hasAny;
      if (!hasAny) noAvailEl.textContent = noAvailMsg;
      calPrev.disabled = (year === now.getFullYear() && month <= now.getMonth());

    }

    function selectDate(key) {
      state.selectedDate = key;
      state.selectedSlot = null;
      bookBtn.disabled = true;
      dlPush('sales_form_date_selected');
      renderCalendar();

      var slots = getSlotsForDay(key);
      timesHead.textContent = formatDateShort(key);
      timesList.innerHTML = '';
      slots.sort(function (a, b) { return a.start - b.start; });
      slots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'el-hs-meeting__time-btn';
        btn.textContent = formatTime(slot.start);
        btn.addEventListener('click', function () {
          state.selectedSlot = slot;
          timesList.querySelectorAll('.is-selected').forEach(function (el) { el.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          bookBtn.disabled = false;
          dlPush('sales_form_time_selected');
        });
        timesList.appendChild(btn);
      });
      timesWrap.hidden = false;

      // Scroll to the time slots
      var headerEl = document.querySelector('.site-header');
      var scrollOffset = (headerEl ? headerEl.offsetHeight : 0) + 40;
      var timesTop = timesWrap.getBoundingClientRect().top + window.scrollY - scrollOffset;
      window.scrollTo({ top: timesTop, behavior: 'smooth' });
    }

    // Month navigation
    calPrev.addEventListener('click', function () {
      if (state.viewMonth === 0) { state.viewMonth = 11; state.viewYear--; } else { state.viewMonth--; }
      state.selectedDate = null; state.selectedSlot = null; timesWrap.hidden = true; bookBtn.disabled = true;
      fetchPublicMonth(state.viewYear, state.viewMonth);
      renderCalendar();
    });

    calNext.addEventListener('click', function () {
      if (state.viewMonth === 11) { state.viewMonth = 0; state.viewYear++; } else { state.viewMonth++; }
      state.selectedDate = null; state.selectedSlot = null; timesWrap.hidden = true; bookBtn.disabled = true;
      fetchPublicMonth(state.viewYear, state.viewMonth);
      renderCalendar();
    });

    // ── Free email domain check ─────────────────────────────────────
    // Loaded from the same CSV the PHP backend uses for server-side validation.
    // Fetched lazily — see fetchFreeEmailDomains below.
    var freeEmailDomains = null;

    // 65 KB CSV; fetching it on DOMContentLoaded put it on Lighthouse's
    // critical-path latency for landing pages where the meeting widget sits
    // below the fold. Defer to the same IntersectionObserver that gates
    // fetchMeetingConfig(). isFreeEmail() handles the not-yet-loaded case
    // by returning false (server-side validation is the source of truth
    // anyway — this is purely for inline UX feedback in the form).
    function fetchFreeEmailDomains() {
      if (freeEmailDomains !== null) return;
      var csvUrl = section.dataset.themeUrl + '/free-domains-2.csv';
      fetch(csvUrl)
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (text) {
          if (!text) return;
          freeEmailDomains = {};
          text.split('\n').forEach(function (line) {
            var d = line.trim().toLowerCase();
            if (d) freeEmailDomains[d] = true;
          });
        })
        .catch(function () { /* CSV unavailable — server-side check is the fallback */ });
    }

    function isFreeEmail(email) {
      if (!freeEmailDomains) return false; // CSV not loaded — let server-side validate
      var domain = (email.toLowerCase().split('@')[1] || '').trim();
      return !!freeEmailDomains[domain];
    }

    // ── Step 1: Render dynamic form ────────────────────────────────
    // Fields that should be paired half-half in the same row
    var halfPairs = { 'firstName': 'lastName', 'role_in_the_company': 'country' };

    function renderFormStep() {
      formFieldsEl.innerHTML = '';
      var baseFields = [
        { name: 'firstName', label: 'First Name', type: 'text', required: true },
        { name: 'lastName', label: 'Last Name', type: 'text', required: true },
        { name: 'email', label: 'Your email address', type: 'email', required: true }
      ];
      var optionalOverrides = ['role_in_the_company'];
      var allFields = baseFields.concat(state.formFields.map(function (f) {
        var required = optionalOverrides.indexOf(f.name) !== -1 ? false : f.isRequired;
        return { name: f.name, label: f.label, type: f.fieldType || 'text', required: required };
      }));

      // Track which fields are the second half of a pair (skip them in the loop)
      var secondHalves = {};
      Object.keys(halfPairs).forEach(function (k) { secondHalves[halfPairs[k]] = true; });

      var checkSvg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12.5L10 17.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var xSvg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>';

      function createField(f, isHalf) {
        var group = document.createElement('div');
        group.className = 'el-hs-meeting__form-group' + (isHalf ? ' el-hs-meeting__form-group--half' : '');
        var label = document.createElement('label');
        label.className = 'el-hs-meeting__form-label';
        label.textContent = f.label + (f.required ? '*' : '');
        label.setAttribute('for', 'hs-field-' + f.name);
        var input = document.createElement('input');
        input.className = 'el-hs-meeting__form-input';
        input.type = f.type === 'email' ? 'email' : 'text';
        input.name = f.name;
        input.id = 'hs-field-' + f.name;
        if (f.required) input.required = true;
        group.appendChild(label);
        group.appendChild(input);

        // Validation icons (hidden by default; toggled via .is-valid / .is-invalid on group)
        var iconValid = document.createElement('span');
        iconValid.className = 'el-hs-meeting__form-icon el-hs-meeting__form-icon--valid';
        iconValid.innerHTML = checkSvg;
        var iconInvalid = document.createElement('span');
        iconInvalid.className = 'el-hs-meeting__form-icon el-hs-meeting__form-icon--invalid';
        iconInvalid.innerHTML = xSvg;
        group.appendChild(iconValid);
        group.appendChild(iconInvalid);

        return group;
      }

      // Build into a detached fragment and insert once. Appending field by
      // field into the live container invalidates layout on every write,
      // and any interleaved read (IntersectionObserver callbacks, etc.)
      // then forces a synchronous reflow — this loop was the top caller in
      // the Lighthouse forced-reflow audit (TIC-629).
      var fieldsFragment = document.createDocumentFragment();

      allFields.forEach(function (f) {
        // Skip if this field is the second half of a pair (already rendered)
        if (secondHalves[f.name]) return;

        if (halfPairs[f.name]) {
          // Render as a half-half row
          var pairName = halfPairs[f.name];
          var pairField = allFields.find(function (ff) { return ff.name === pairName; });
          var row = document.createElement('div');
          row.className = 'el-hs-meeting__form-row';
          row.appendChild(createField(f, true));
          if (pairField) row.appendChild(createField(pairField, true));
          fieldsFragment.appendChild(row);
        } else {
          fieldsFragment.appendChild(createField(f, false));
        }
      });

      formFieldsEl.appendChild(fieldsFragment);
    }

    // Validate a single input — used on blur and on submit.
    // Returns true if valid. Toggles classes on the form-group.
    function validateField(input) {
      if (!input.classList || !input.classList.contains('el-hs-meeting__form-input')) return true;
      var group = input.closest('.el-hs-meeting__form-group');
      if (!group) return true;
      var value = input.value.trim();

      // Remove any previous hint when re-validating
      var oldHint = group.querySelector('.el-hs-meeting__field-hint');
      if (oldHint) oldHint.remove();

      group.classList.remove('is-valid', 'is-invalid');

      // Required + empty
      if (input.required && !value) {
        group.classList.add('is-invalid');
        return false;
      }
      // Empty optional field — no icon
      if (!value) return true;
      // Email format
      if (input.type === 'email' && !input.validity.valid) {
        group.classList.add('is-invalid');
        return false;
      }
      // Free email domain
      if (input.type === 'email' && isFreeEmail(value)) {
        group.classList.add('is-invalid');
        var hint = document.createElement('span');
        hint.className = 'el-hs-meeting__field-hint';
        hint.textContent = 'Please use your business email address.';
        group.appendChild(hint);
        return false;
      }
      group.classList.add('is-valid');
      return true;
    }

    // Validate on blur (focusout bubbles, blur does not).
    form.addEventListener('focusout', function (e) {
      if (e.target.classList && e.target.classList.contains('el-hs-meeting__form-input')) {
        validateField(e.target);
      }
    });

    // Clear error on user input
    form.addEventListener('input', function (e) {
      if (e.target.classList.contains('el-hs-meeting__field-error')) {
        e.target.classList.remove('el-hs-meeting__field-error');
        var group = e.target.closest('.el-hs-meeting__form-group');
        var hint = group && group.querySelector('.el-hs-meeting__field-hint');
        if (hint) hint.remove();
      }
      // Also clear stale validation state while typing — the field will be
      // re-validated on next blur.
      var grp = e.target.closest('.el-hs-meeting__form-group');
      if (grp) grp.classList.remove('is-valid', 'is-invalid');
    });
    form.addEventListener('change', function (e) {
      if (e.target.classList.contains('el-hs-meeting__field-error')) {
        e.target.classList.remove('el-hs-meeting__field-error');
      }
      // Clear error on parent wrapper for checkboxes
      var wrap = e.target.closest('.el-hs-meeting__field-error');
      if (wrap) wrap.classList.remove('el-hs-meeting__field-error');
    });

    // Back → return to form
    if (backLink) backLink.addEventListener('click', function () { goToStep(1); });

    // ── Form submit → go to calendar (step 2) ─────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Store form data in state
      state.formData = {};
      var inputs = form.querySelectorAll('input[name], select[name], textarea[name]');
      var valid = true;
      // Clear previous errors
      form.querySelectorAll('.el-hs-meeting__field-error').forEach(function (el) { el.classList.remove('el-hs-meeting__field-error'); });

      inputs.forEach(function (inp) {
        if (inp.type === 'checkbox') {
          if (inp.required && !inp.checked) {
            valid = false;
            var checkWrap = inp.closest('.el-hs-meeting__legal-checkbox');
            if (checkWrap) checkWrap.classList.add('el-hs-meeting__field-error');
          }
          return;
        }
        state.formData[inp.name] = inp.value.trim();
        if (inp.required && !inp.value.trim()) {
          valid = false;
          inp.classList.add('el-hs-meeting__field-error');
        } else if (inp.type === 'email' && inp.value.trim() && !inp.validity.valid) {
          valid = false;
          inp.classList.add('el-hs-meeting__field-error');
        } else if (inp.type === 'email' && inp.value.trim() && isFreeEmail(inp.value.trim())) {
          valid = false;
          inp.classList.add('el-hs-meeting__field-error');
          var group = inp.closest('.el-hs-meeting__form-group');
          if (group && !group.querySelector('.el-hs-meeting__field-hint')) {
            var hint = document.createElement('span');
            hint.className = 'el-hs-meeting__field-hint';
            hint.textContent = 'Please use your business email address.';
            group.appendChild(hint);
          }
        }
      });

      if (!valid) {
        var firstError = form.querySelector('.el-hs-meeting__field-error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      dlPush('sales_form_user_data');

      // Fire-and-forget partial capture to HubSpot Forms API. Lets sales
      // follow up on Step-1 finishers who don't book a time. We don't await
      // it or block the UX on failure — the booking flow is unaffected if
      // the partial submission errors. TIC-567.
      if (partialForm && state.formData && state.formData.email) {
        var partialFd = new FormData();
        partialFd.append('action', 'farseer_hubspot_meeting_partial');
        partialFd.append('nonce', nonce);
        partialFd.append('form', partialForm);
        partialFd.append('slug', slug);
        partialFd.append('_pageUri', window.location.href);
        partialFd.append('_pageName', document.title);
        Object.keys(state.formData).forEach(function (k) {
          if (state.formData[k] !== undefined && state.formData[k] !== '') {
            partialFd.append(k, state.formData[k]);
          }
        });
        fetch(ajaxUrl, { method: 'POST', body: partialFd, credentials: 'same-origin' })
          .catch(function () { /* silent — booking flow continues regardless */ });
      }

      renderDurations();
      renderCalendar();
      // Auto-select the first available date so times show right away.
      var firstAvailable = findFirstAvailableDate();
      if (firstAvailable) {
        selectDate(firstAvailable);
      }
      goToStep(2);
    });

    // ── Confirm button → book meeting ───────────────────────────
    bookBtn.addEventListener('click', function () {
      if (!state.selectedSlot) return;

      bookBtn.disabled = true;
      var origText = bookBtn.textContent;
      bookBtn.textContent = 'Booking\u2026';
      hideMsg();

      var data = {
        slug: slug,
        startTime: state.selectedSlot.start,
        duration: state.selectedDuration,
        timezone: state.tz,
        locale: state.locale
      };
      // Include all form field values from state
      if (state.formData) {
        Object.keys(state.formData).forEach(function (k) {
          if (state.formData[k] !== undefined && state.formData[k] !== '') {
            data[k] = state.formData[k];
          }
        });
      }

      post('farseer_hubspot_meeting_book', data)
        .then(function (json) {
          if (json.success) {
            confirmHead.textContent = successHd;
            confirmText.textContent = successMsg;
            var r = json.data;
            confirmDets.textContent = '';
            if (r.start) {
              confirmDets.appendChild(document.createTextNode(
                new Intl.DateTimeFormat(state.locale, {
                  timeZone: state.tz, weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
                  hour: 'numeric', minute: '2-digit'
                }).format(new Date(r.start))
              ));
            }
            if (r.subject) { confirmDets.appendChild(document.createElement('br')); confirmDets.appendChild(document.createTextNode(r.subject)); }
            if (r.location) { confirmDets.appendChild(document.createElement('br')); confirmDets.appendChild(document.createTextNode(r.location)); }
            dlPush('generate_lead');
            goToStep(3);
          } else {
            showMsg(json.data || errorMsg, 'error');
            if (json.data && json.data.indexOf('no longer available') !== -1) {
              state.slotsByDate = {};
              state.selectedSlot = null;
              state.selectedDate = null;
              timesWrap.hidden = true;
              bookBtn.disabled = true;
              goToStep(2);
            }
          }
        })
        .catch(function () { showMsg(errorMsg, 'error'); })
        .finally(function () { bookBtn.disabled = false; bookBtn.textContent = origText; });
    });

    // ── Init: fetch config + availability when the section nears the
    //    viewport (or immediately if it's already in view).
    //
    // The availability call hits admin-ajax.php which round-trips to the
    // HubSpot Meetings API — ~600-800 ms on a cold cache. Previously fired
    // unconditionally on DOMContentLoaded, which put it in Lighthouse's
    // critical-path latency for landing pages where the meeting widget
    // sits below the fold (financial-reporting-software-lp et al). With
    // an IntersectionObserver + 500 px rootMargin, the fetch starts when
    // the user is roughly one viewport away — typically enough lead time
    // for the API to respond before the section becomes visible.
    //
    // On pages where the widget is already above the fold (/book-a-demo/
    // is the canonical example), the observer's initial callback fires
    // synchronously on observe() with isIntersecting=true, so the fetch
    // still kicks off immediately — no regression for those pages.
    //
    // Falls back to immediate fetch if IntersectionObserver isn't
    // available (very old browsers).
    if ('IntersectionObserver' in window) {
      var configObserver = new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) {
          obs.disconnect();
          fetchMeetingConfig();
          fetchFreeEmailDomains();
        }
      }, { rootMargin: '500px 0px 500px 0px' });
      configObserver.observe(section);
    } else {
      fetchMeetingConfig();
      fetchFreeEmailDomains();
    }

    // ── Quotes carousel (within meeting section) ────────────────
    var quotesWrap = section.querySelector('[data-hs-quotes]');
    if (quotesWrap) {
      var qSlides = quotesWrap.querySelectorAll('.el-hs-meeting__quote-slide');
      var qTotal = qSlides.length;
      if (qTotal > 1) {
        var qCurrentSpan = quotesWrap.querySelector('.el-hs-meeting__quote-current');
        var qPrev = quotesWrap.querySelector('.el-hs-meeting__quote-btn--prev');
        var qNext = quotesWrap.querySelector('.el-hs-meeting__quote-btn--next');
        var qIndex = 0;

        function showQuote(idx) {
          qIndex = (idx + qTotal) % qTotal;
          qSlides.forEach(function (s, i) { s.classList.toggle('hidden', i !== qIndex); });
          if (qCurrentSpan) qCurrentSpan.textContent = String(qIndex + 1).padStart(2, '0');
        }

        if (qPrev) qPrev.addEventListener('click', function () { showQuote(qIndex - 1); });
        if (qNext) qNext.addEventListener('click', function () { showQuote(qIndex + 1); });
        showQuote(0);
      }
    }
  });

  // ==========================================================================
  // On-Page Navigation
  // Floating jump-link bar (template-parts/global/onpage-nav.php).
  //   - Hidden when scrollY < 200; slides in past the threshold.
  //   - Main nav hides on scroll-down, returns on scroll-up (stacking).
  //   - Active section tracked via IntersectionObserver.
  //   - Mobile: drop-up trigger replaces the inline list.
  // ==========================================================================
  (function () {
    // Gate on the nav element existing (rendered by PHP only when at least
    // one element has an on-page nav label). Don't gate on body class —
    // the body_class filter can race against ACF state in edge cases.
    var nav = document.querySelector('[data-onpage-nav]');
    if (!nav) return;

    // Always tag the body so CSS can target on-page-nav pages reliably.
    document.body.classList.add('has-onpage-nav');

    var links = Array.prototype.slice.call(nav.querySelectorAll('.onpage-nav__link'));
    if (!links.length) return;

    var currentBtn   = nav.querySelector('.onpage-nav__current');
    var currentLabel = nav.querySelector('[data-onpage-current]');
    var header       = document.querySelector('.site-header');

    var THRESHOLD        = 200;
    var TOP_BUFFER       = 50;     // below this, force main nav visible
    var SCROLL_TOLERANCE = 4;      // ignore tiny scroll jitter

    // Build link → section map and prune links whose section is missing.
    var pairs = [];
    links.forEach(function (link) {
      var id = link.getAttribute('data-target');
      var sec = id ? document.getElementById(id) : null;
      if (sec) pairs.push({ link: link, section: sec });
    });
    if (!pairs.length) return;

    // Publish header height as CSS var for the stacking-on-scroll-up offset.
    function syncHeaderHeight() {
      var h = header ? header.offsetHeight : 56;
      document.documentElement.style.setProperty('--site-header-h', h + 'px');
    }
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);
    window.addEventListener('load', syncHeaderHeight);

    // ── Scroll direction + threshold ────────────────────────────────
    var lastScrollY = window.scrollY;
    var ticking = false;
    // True while a click-driven smooth-scroll is in progress; suppresses the
    // direction-based main-nav reveal so clicking an on-page nav item that
    // scrolls UP doesn't accidentally bring the main nav back.
    var isProgrammaticScroll = false;
    var endProgrammaticTimer = null;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.scrollY;
        var dy = y - lastScrollY;
        var body = document.body;

        // Threshold-based — always evaluated.
        if (y > THRESHOLD) {
          body.classList.add('is-onpage-nav-active');
        } else {
          body.classList.remove('is-onpage-nav-active');
        }

        // Direction-based — skipped while programmatically scrolling.
        if (!isProgrammaticScroll) {
          if (y < TOP_BUFFER) {
            body.classList.add('is-main-nav-visible');
          } else if (Math.abs(dy) > SCROLL_TOLERANCE) {
            if (dy < 0) {
              // scrolling up
              body.classList.add('is-main-nav-visible');
            } else if (y > THRESHOLD) {
              // scrolling down past threshold — hide main nav
              body.classList.remove('is-main-nav-visible');
            }
          }
        }

        lastScrollY = y;
      });
    }
    // Seed initial state
    if (lastScrollY < TOP_BUFFER) {
      document.body.classList.add('is-main-nav-visible');
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // ── Active section tracking via IntersectionObserver ────────────
    function setActive(link) {
      pairs.forEach(function (p) {
        p.link.classList.toggle('is-active', p.link === link);
      });
      if (currentLabel && link) {
        currentLabel.textContent = link.textContent.trim();
      }
    }

    // Track which sections are currently in the active band so that we can
    // pick the topmost one when several intersect at once. When the band is
    // empty (nothing on screen we'd consider "the current section") we clear
    // every link's active state so no stale highlight remains.
    var inView = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          inView.add(entry.target);
        } else {
          inView.delete(entry.target);
        }
      });
      if (!inView.size) {
        setActive(null);
        return;
      }
      // Pick the section closest to the top of the viewport.
      var topMost = null;
      var topY = Infinity;
      inView.forEach(function (sec) {
        var y = sec.getBoundingClientRect().top;
        if (y < topY) { topY = y; topMost = sec; }
      });
      var match = pairs.find(function (p) { return p.section === topMost; });
      if (match) setActive(match.link);
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });

    pairs.forEach(function (p) { observer.observe(p.section); });

    // ── Click handler — smooth scroll with offset ────────────────────
    function smoothScrollTo(section) {
      // Treat the click as programmatic so the scroll handler ignores the
      // direction it produces (prevents the main nav from sliding back in
      // when a click scrolls UP to a section above current position).
      isProgrammaticScroll = true;
      clearTimeout(endProgrammaticTimer);

      // Compute target with main nav assumed hidden — we want the section to
      // line up just below the on-page nav, not below a (about-to-reappear)
      // main nav.
      var navH = nav.offsetHeight || 0;
      var top = section.getBoundingClientRect().top + window.scrollY - navH - 8;
      window.scrollTo({ top: top, behavior: 'smooth' });

      // Clear the flag once the smooth scroll settles. Use scrollend if the
      // browser supports it; otherwise fall back to a generous timer.
      var done = function () {
        isProgrammaticScroll = false;
        // If the click landed us at the very top, restore the top-of-page
        // rule (main nav visible).
        if (window.scrollY < TOP_BUFFER) {
          document.body.classList.add('is-main-nav-visible');
        }
      };
      if ('onscrollend' in window) {
        window.addEventListener('scrollend', done, { once: true });
        // Safety net in case scrollend never fires (e.g. distance was 0).
        endProgrammaticTimer = setTimeout(done, 1500);
      } else {
        endProgrammaticTimer = setTimeout(done, 1000);
      }
    }

    pairs.forEach(function (p) {
      p.link.addEventListener('click', function (e) {
        e.preventDefault();
        smoothScrollTo(p.section);
        // Close mobile drop-up if open
        if (currentBtn) currentBtn.setAttribute('aria-expanded', 'false');
        // Update URL hash without jumping
        if (history.replaceState) {
          history.replaceState(null, '', '#' + p.section.id);
        }
      });
    });

    // ── Mobile drop-up toggle ───────────────────────────────────────
    if (currentBtn) {
      currentBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = currentBtn.getAttribute('aria-expanded') === 'true';
        currentBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
      // Click-outside to close.
      document.addEventListener('click', function (e) {
        if (currentBtn.getAttribute('aria-expanded') !== 'true') return;
        if (nav.contains(e.target)) return;
        currentBtn.setAttribute('aria-expanded', 'false');
      });
      // Reset open state when crossing into desktop breakpoint.
      var mq = window.matchMedia('(min-width: 768px)');
      var onMQ = function () {
        if (mq.matches) currentBtn.setAttribute('aria-expanded', 'false');
      };
      if (mq.addEventListener) mq.addEventListener('change', onMQ);
      else if (mq.addListener) mq.addListener(onMQ);
    }
  })();

  // ==========================================================================
  // On-page nav — hide when the booking form (#meeting) is in view.
  // Adds .onpage-nav--form-visible to every .onpage-nav while #meeting
  // intersects the viewport (minus a trigger offset so a tiny nudge near
  // the boundary doesn't toggle the nav). Safe no-op on pages without the
  // form or without an on-page nav.
  // ==========================================================================
  (function () {
    var FORM_TRIGGER_OFFSET = 280; // px; nav hides only after the form has
                                    // crossed this far into the viewport.

    var form = document.querySelector('#meeting');
    if (!form) return;
    var navs = document.querySelectorAll('.onpage-nav');
    if (!navs.length) return;
    if (typeof IntersectionObserver === 'undefined') return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        navs.forEach(function (nav) {
          nav.classList.toggle('onpage-nav--form-visible', entry.isIntersecting);
        });
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px -' + FORM_TRIGGER_OFFSET + 'px 0px'
    });

    io.observe(form);
  })();

  // ==========================================================================
  // Sticky Post CTA
  // The .single-layout__cta card sits in flow underneath the TOC. The
  // moment its in-flow position would scroll into view from the bottom
  // of the viewport, swap it to position: fixed pinned at the bottom of
  // the screen, matching the sidebar column's left + width.
  // ==========================================================================
  (function () {
    var cta = document.querySelector('.single-layout__cta');
    if (!cta) return;
    var sidebar = cta.closest('.single-layout__toc');
    if (!sidebar) return;
    var tocBox = sidebar.querySelector('.single-layout__toc-box');

    // CTA's natural bottom in document coords. Captured while the card is
    // in flow; recomputed on resize. Equals the scrollY at which the card's
    // bottom edge would touch the bottom of the viewport.
    var naturalDocBottom = 0;
    // Bottom offset (px) from the viewport edge while stuck — captured once
    // from the computed `bottom` of the stuck card so the sticky trigger
    // lines up exactly with the resting position (no visual snap on engage).
    var stickyOffsetPx = -1;
    // Sticky-top offset of the TOC card as defined in CSS. Captured once
    // before we override it inline.
    var tocDefaultTop = -1;

    function captureNatural() {
      // Reset to in-flow so the natural rect is accurate.
      if (cta.classList.contains('is-stuck')) {
        cta.classList.remove('is-stuck');
        cta.style.left = '';
        cta.style.width = '';
        cta.style.bottom = '';
      }
      // Sidebar hidden (mobile) — bail out; never engage.
      if (!sidebar.offsetParent) {
        naturalDocBottom = -1;
        if (tocBox) tocBox.style.top = '';
        return;
      }
      var rect = cta.getBoundingClientRect();
      naturalDocBottom = rect.bottom + window.scrollY;
      // First time only: read the sticky `bottom` value off the card.
      if (stickyOffsetPx < 0) {
        cta.classList.add('is-stuck');
        stickyOffsetPx = parseFloat(getComputedStyle(cta).bottom) || 0;
        cta.classList.remove('is-stuck');
      }
      // First time only: read the CSS-defined sticky top offset of the TOC.
      if (tocBox && tocDefaultTop < 0) {
        // Make sure no inline override is in effect when reading.
        var inlineTop = tocBox.style.top;
        tocBox.style.top = '';
        tocDefaultTop = parseFloat(getComputedStyle(tocBox).top) || 0;
        if (inlineTop) tocBox.style.top = inlineTop;
      }
    }

    // Push the TOC card up so its bottom always stays above the CTA's
    // current top (with the sidebar gap preserved). The TOC keeps its full
    // natural height — only its sticky-top offset moves.
    function syncTocPosition(ctaTopInViewport) {
      if (!tocBox || tocDefaultTop < 0 || !sidebar.offsetParent) return;
      var gap = parseFloat(getComputedStyle(sidebar).rowGap) || 0;
      var tocHeight = tocBox.offsetHeight;
      var maxAllowedTop = ctaTopInViewport - gap - tocHeight;
      var desiredTop = Math.min(tocDefaultTop, maxAllowedTop);
      if (desiredTop >= tocDefaultTop) {
        // Default — let CSS sticky-top handle it.
        tocBox.style.top = '';
      } else {
        tocBox.style.top = desiredTop + 'px';
      }
    }

    var rafPending = false;
    function update() {
      rafPending = false;
      if (naturalDocBottom < 0) return;
      // Engage as soon as the in-flow bottom of the card would scroll past
      // its resting (stuck) line — i.e., the moment the user can see it
      // entering from the bottom of the viewport.
      var shouldStick = window.scrollY + window.innerHeight - stickyOffsetPx > naturalDocBottom;
      var ctaTopInViewport;
      if (!shouldStick) {
        if (cta.classList.contains('is-stuck')) {
          cta.classList.remove('is-stuck');
          cta.style.left = '';
          cta.style.width = '';
          cta.style.bottom = '';
        }
        // CTA in flow — its top in viewport = natural top - scrollY.
        ctaTopInViewport = (naturalDocBottom - cta.offsetHeight) - window.scrollY;
      } else {
        // Stuck. Match the sidebar column's left/width and cap the bottom
        // offset so the card never extends past the bottom of the sidebar
        // (which is what releases it onto the footer area).
        var sbRect = sidebar.getBoundingClientRect();
        cta.classList.add('is-stuck');
        cta.style.left = sbRect.left + 'px';
        cta.style.width = sbRect.width + 'px';
        // `bottom` (px from viewport edge) grows as the sidebar bottom rises
        // above the resting line, parking the card at the column's end.
        var bottomPx = Math.max(stickyOffsetPx, window.innerHeight - sbRect.bottom);
        cta.style.bottom = bottomPx + 'px';
        ctaTopInViewport = window.innerHeight - bottomPx - cta.offsetHeight;
      }
      // Shift the whole TOC up in lockstep with the CTA's current top so the
      // bottom never crosses into the CTA, without resizing the card.
      syncTocPosition(ctaTopInViewport);
    }

    function onScroll() {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(update);
      }
    }

    function onResize() {
      captureNatural();
      update();
    }

    captureNatural();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    // Web fonts / images can shift the natural position after first paint —
    // re-measure once everything has loaded.
    window.addEventListener('load', onResize);
  })();

  // ==========================================================================
  // Video Popup
  // Single global overlay (template-parts/global/video-popup.php) that any
  // element can open by including a [data-video-popup-trigger] button with
  // a sibling <template data-video-popup-source> holding either a <video>
  // or <iframe> element. Click the trigger → clone the source into the
  // popup, play, wire up play/mute/close. ESC and backdrop close.
  // ==========================================================================
  (function () {
    var popup = document.querySelector('[data-video-popup]');
    if (!popup) return;

    var media       = popup.querySelector('[data-video-popup-media]');
    var playBtn     = popup.querySelector('[data-video-popup-toggle="play"]');
    var muteBtn     = popup.querySelector('[data-video-popup-toggle="mute"]');
    var closeBtns   = popup.querySelectorAll('[data-video-popup-close]');
    var lastTrigger = null;

    function setIcon(button, activeKey) {
      if (!button) return;
      button.querySelectorAll('[data-icon]').forEach(function (icon) {
        icon.hidden = icon.getAttribute('data-icon') !== activeKey;
      });
    }

    function getMediaEl() {
      return media.querySelector('video, iframe');
    }

    function open(trigger) {
      var template = trigger.parentNode && trigger.parentNode.querySelector('[data-video-popup-source]');
      if (!template) return;

      // Replace any previous content with a fresh clone of the source.
      media.replaceChildren(template.content.cloneNode(true));
      var el = getMediaEl();
      if (!el) return;

      lastTrigger = trigger;

      // Reset control state.
      setIcon(playBtn, 'pause');
      setIcon(muteBtn, 'sound');
      if (playBtn) playBtn.setAttribute('aria-label', 'Pause');
      if (muteBtn) muteBtn.setAttribute('aria-label', 'Mute');

      // For HTML5 video, autoplay (the click counts as user gesture).
      // For iframes, the source markup should already include autoplay
      // params (e.g. ?autoplay=1) — set up on render via farseer_oembed.
      if (el.tagName === 'VIDEO') {
        el.controls = false;
        el.setAttribute('playsinline', '');
        el.muted = false;
        try { el.play(); } catch (_) {}
      }

      // Reveal + lock background scroll.
      popup.hidden = false;
      // Force a reflow before adding .is-open so the opacity transition fires.
      void popup.offsetWidth;
      popup.classList.add('is-open');
      document.documentElement.classList.add('has-video-popup');

      // Hide controls bar entirely for iframes — we can't drive them
      // reliably without postMessage integration, so the iframe's own
      // controls handle play/volume.
      var controls = popup.querySelector('.video-popup__controls');
      if (controls) {
        if (playBtn) playBtn.hidden = el.tagName !== 'VIDEO';
        if (muteBtn) muteBtn.hidden = el.tagName !== 'VIDEO';
      }
    }

    function close() {
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('has-video-popup');
      // Wait for the fade to finish, then unmount the media so it stops
      // playing and frees resources.
      var done = function () {
        popup.hidden = true;
        media.replaceChildren();
        popup.removeEventListener('transitionend', done);
      };
      popup.addEventListener('transitionend', done);
      // Safety fallback if transitionend never fires.
      setTimeout(done, 400);

      // Also stop the media immediately so audio cuts on click.
      var el = getMediaEl();
      if (el && el.tagName === 'VIDEO') {
        try { el.pause(); } catch (_) {}
      }
      if (el && el.tagName === 'IFRAME') {
        // Removing the src is the cheapest way to stop the iframe video.
        try { el.src = el.src; } catch (_) {} // eslint-disable-line no-self-assign
      }

      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    function togglePlay() {
      var el = getMediaEl();
      if (!el || el.tagName !== 'VIDEO') return;
      if (el.paused) {
        el.play().catch(function () {});
        setIcon(playBtn, 'pause');
        if (playBtn) playBtn.setAttribute('aria-label', 'Pause');
      } else {
        el.pause();
        setIcon(playBtn, 'play');
        if (playBtn) playBtn.setAttribute('aria-label', 'Play');
      }
    }

    function toggleMute() {
      var el = getMediaEl();
      if (!el || el.tagName !== 'VIDEO') return;
      el.muted = !el.muted;
      setIcon(muteBtn, el.muted ? 'muted' : 'sound');
      if (muteBtn) muteBtn.setAttribute('aria-label', el.muted ? 'Unmute' : 'Mute');
    }

    // Open — delegate so triggers added later (e.g. dynamic content) work.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-video-popup-trigger]');
      if (!trigger) return;
      e.preventDefault();
      open(trigger);
    });

    // Close handlers.
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    // Controls.
    if (playBtn) playBtn.addEventListener('click', togglePlay);
    if (muteBtn) muteBtn.addEventListener('click', toggleMute);
  })();

  // ==========================================================================
  // Calculator — dataLayer push on interaction
  // ==========================================================================
  document.querySelectorAll('[data-calculator-name]').forEach(function (embed) {
    var calcName = embed.dataset.calculatorName;
    var fired = false;
    var interacted = false;

    function pushCalcEvent() {
      if (fired || !window.dataLayer) return;
      fired = true;
      window.dataLayer.push({
        event: 'calculator_interaction',
        calculator_name: calcName
      });
    }

    // Track when user has actually entered data.
    embed.addEventListener('input', function () { interacted = true; });

    // Fire on any DOM mutation inside the embed AFTER user interaction.
    // This catches all calculator structures regardless of class names.
    var observer = new MutationObserver(function () {
      if (interacted) pushCalcEvent();
    });
    observer.observe(embed, { childList: true, subtree: true, characterData: true });

    // Also catch button-driven calculations where the user clicks without typing
    // (e.g. pre-filled values).
    embed.addEventListener('click', function (e) {
      var btn = e.target.closest('button, [type="submit"]');
      if (btn && !/reset|clear/i.test(btn.textContent)) {
        // Defer to let the calculator update the DOM first.
        setTimeout(pushCalcEvent, 50);
      }
    });
  });

  // ==========================================================================
  // HubSpot & Ashby iframe form — dataLayer push via postMessage
  // ==========================================================================
  window.addEventListener('message', function (e) {
    if (!window.dataLayer) return;

    // HubSpot iframe forms send a postMessage on submission.
    // data.submissionValues contains field values when available.
    if (e.data && e.data.type === 'hsFormCallback' && e.data.eventName === 'onFormSubmitted') {
      var v = (e.data.data && e.data.data.submissionValues) || {};
      window.dataLayer.push({
        event: 'generate_lead_content',
        form_name: v.form_name || e.data.id || '',
        first_name: v.firstname || v.firstName || '',
        last_name: v.lastname || v.lastName || '',
        email: v.email || '',
        company_name: v.company || v.company_name || '',
        role: v.jobtitle || v.role || '',
        country_free_entry: v.country || v.country_free_entry || '',
        form_message: v.message || v.form_message || ''
      });
    }

  });

  // Ashby — detect application submission via ?ashby_jid= redirect parameter.
  var ashbyJid = new URLSearchParams(window.location.search).get('ashby_jid');
  if (ashbyJid) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'career_apply',
      job_id: ashbyJid
    });
  }

  // ==========================================================================
  // Footer banner — pause the infinite clip-path wipe when scrolled away.
  // 4 stacked `will-change: clip-path` animations running forever burn GPU
  // even when off-screen (Safari especially); toggling animation-play-state
  // via .site-footer__banner--paused is what restores FPS over long sessions.
  // ==========================================================================
  (function () {
    var banner = document.querySelector('.site-footer__banner');
    if (!banner || banner.classList.contains('site-footer__banner--static')) return;
    if (typeof IntersectionObserver === 'undefined') return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        banner.classList.toggle('site-footer__banner--paused', !entry.isIntersecting);
      });
    }, { rootMargin: '100px 0px' });

    io.observe(banner);
    // Start paused — IO fires once on observe with the current state.
  })();

  // ==========================================================================
  // Media Slider (TIC-674)
  // Arrows are an enhancement on top of native horizontal scrolling — the
  // track scrolls by touch, trackpad and keyboard whether or not this runs.
  // The nav ships hidden and only unhides on genuine overflow, so a two-card
  // row, or three cards that happen to fit on a wide screen, never shows dead
  // controls. Video playback is not handled here: the cards are standard
  // [data-video-popup-trigger] elements picked up by the popup module above.
  // ==========================================================================
  (function () {
    var sections = document.querySelectorAll('[data-media-slider]');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    sections.forEach(function (section) {
      var track = section.querySelector('[data-media-slider-track]');
      var nav   = section.querySelector('[data-media-slider-nav]');
      if (!track || !nav) return;

      var prev  = section.querySelector('[data-media-slider-prev]');
      var next  = section.querySelector('[data-media-slider-next]');
      var count = parseInt(section.getAttribute('data-count'), 10) || track.children.length;

      function update() {
        // Two cards flex to fill the row on desktop, so they can never overflow
        // in a way worth paging through.
        if (count <= 2) {
          nav.hidden = true;
          return;
        }

        // 1px of slack absorbs sub-pixel rounding — at fractional zoom an exact
        // fit otherwise reports as permanent overflow.
        var overflows = track.scrollWidth > track.clientWidth + 1;
        nav.hidden = !overflows;
        if (!overflows) return;

        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      function step(direction) {
        var card = track.querySelector('.el-media-slider__card');
        if (!card) return;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        track.scrollBy({
          left: (card.offsetWidth + gap) * direction,
          // An explicit behavior beats the stylesheet, so opt out here too.
          behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var frame = null;
      function schedule() {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }

      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      // Card widths come from CSS, so the track measures correctly before the
      // thumbnails decode — but re-check after load in case a webfont or a
      // late stylesheet moved things.
      window.addEventListener('load', schedule);

      update();
    });
  })();

})();
